const ON_CHANGE_DEBOUNCE_TIMER = 300
  , currentDate = new Date()
  , PUB_SUB_EVENTS = {
    'cartUpdate': 'cart-update',
    'quantityUpdate': 'quantity-update',
    'variantChange': 'variant-change'
}
  , POST_LINK_INT = 'xml_eval';
let subscribers = {};
function subscribe(eventName, callback) {
    if (subscribers[eventName] === undefined) subscribers[eventName] = [];
    subscribers[eventName].push(callback);
    return function unsubscribe() {
        subscribers[eventName] = subscribers[eventName].filter(fn => fn !== callback);
    };
}
;function publish(eventName, data) {
    subscribers[eventName] && subscribers[eventName].forEach(callback => {
        callback(data);
    });
}
class CartRemoveButton extends HTMLElement {
    constructor() {
        super();
        this.addEventListener('click', (event) => {
            event.preventDefault();
            const cartEl = this.closest('cart-items') || this.closest('cart-drawer-items');
            this.clearCart ? cartEl.clearCart() : cartEl.updateQuantity(this.dataset.index, 0);
        });
    }
}
customElements.define('cart-remove-button', CartRemoveButton);
class CartItems extends HTMLElement {
    constructor() {
        super();
        this.lineItemStatusElement = document.getElementById('shopping-cart-line-item-status') || document.getElementById('CartDrawer-LineItemStatus');
        this.secondCartItems = document.querySelector('cart-drawer-items');
        const debouncedOnChange = debounce((event) => {
            this.onChange(event);
        }, ON_CHANGE_DEBOUNCE_TIMER);
        this.addEventListener('change', debouncedOnChange.bind(this));
    }
    cartUpdateUnsubscriber = undefined;
    connectedCallback() {
        this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
            if (event.source === 'cart-items') return;
            this.onCartUpdate();
        });
    }
    disconnectedCallback() {
        this.cartUpdateUnsubscriber && this.cartUpdateUnsubscriber();
    }
    onChange(event) {
        this.updateQuantity(event.target.dataset.index, event.target.value, document.activeElement.getAttribute('name'));
    }
    onCartUpdate() {
        fetch('/cart?section_id=main-cart-items').then(res => res.text()).then(html => {
            const doc = new DOMParser().parseFromString(html, 'text/html');
            const cartItemsEl = doc.querySelector('cart-items');
            this.innerHTML = cartItemsEl.innerHTML;
        }).catch(error => {
            console.error(error);
        });
    }
    updateCart() {
        const body = JSON.stringify({
            sections: this.getSectionsToRender().map(s => s.section),
            sections_url: window.location.pathname
        });
        fetch('/cart/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: body
        }).then(res => res.json()).then(response => {
            this.classList.toggle('is-empty', response.item_count === 0);
            this.getSectionsToRender().forEach(section => {
                const sectionEl = document.getElementById(section.id);
                const el = sectionEl.querySelector(section.selector) || sectionEl;
                el.innerHTML = this.getSectionInnerHTML(response.sections[section.section], section.selector);
            });
        }).catch(error => {
            console.error(error);
        });
    }
    _sectionsCache = null;
    getSectionsToRender() {
        if (!this._sectionsCache) {
            const mainEl = document.getElementById('main-cart-items');
            const footerEl = document.getElementById('main-cart-footer');
            this._sectionsCache = [
                { id: 'main-cart-items', section: mainEl ? mainEl.dataset.id : 'main-cart-items', selector: '.js-contents' },
                { id: 'cart-icon-bubble', section: 'cart-icon-bubble', selector: '.shopify-section' },
                { id: 'cart-live-region-text', section: 'cart-live-region-text', selector: '.shopify-section' },
                { id: 'main-cart-footer', section: footerEl ? footerEl.dataset.id : 'main-cart-footer', selector: '.js-contents' }
            ];
        }
        return this._sectionsCache;
    }
    async updateQuantity(line, quantity, name) {
        this.enableLoading(line);
        const body = JSON.stringify({
            line: line,
            quantity: quantity,
            sections: this.getSectionsToRender().map(s => s.section),
            sections_url: window.location.pathname
        });
        try {
            const response = await fetch('' + routes.cart_change_url, { ...fetchConfig(), ...{ body } });
            const responseText = await response.text();
            const state = JSON.parse(responseText);
            const quantityElement = document.getElementById('Quantity-' + line) || document.getElementById('Drawer-quantity-' + line);
            const cartItems = document.querySelectorAll('.cart-item');

            if (state.errors) {
                quantityElement.value = quantityElement.getAttribute('value');
                this.updateLiveRegions(line, state.errors);
                return;
            }

            if (!state.sections) {
                const sectionsResponse = await fetch(routes.cart_url + '?sections=' + this.getSectionsToRender().map(s => s.section).join(','));
                state.sections = await sectionsResponse.json();
            }

            this.classList.toggle('is-empty', state.item_count === 0);
            const cartDrawer = document.querySelector('cart-drawer');
            const cartFooter = document.getElementById('main-cart-footer');
            if (cartFooter) cartFooter.classList.toggle('is-empty', state.item_count === 0);
            if (cartDrawer) cartDrawer.classList.toggle('is-empty', state.item_count === 0);

            this.getSectionsToRender().forEach(section => {
                const sectionEl = document.getElementById(section.id);
                const el = sectionEl.querySelector(section.selector) || sectionEl;
                el.innerHTML = this.getSectionInnerHTML(state.sections[section.section], section.selector);
            });

            const updatedQuantity = state.items[line - 1] ? state.items[line - 1].quantity : undefined;
            let message = '';
            cartItems.length === state.items.length && updatedQuantity !== parseInt(quantityElement.value) && (typeof updatedQuantity === 'undefined' ? message = window.cartStrings.error : message = window.cartStrings.quantityError.replace('[quantity]', updatedQuantity));
            this.updateLiveRegions(line, message);

            const lineItem = document.getElementById('CartItem-' + line) || document.getElementById('CartDrawer-Item-' + line);
            const nameInput = lineItem && lineItem.querySelector('[name="' + name + '"]');
            if (nameInput)
                cartDrawer ? trapFocus(cartDrawer, nameInput) : nameInput.focus();
            else {
                if (state.item_count === 0 && cartDrawer)
                    trapFocus(cartDrawer.querySelector('.drawer__inner-empty'), cartDrawer.querySelector('a'));
                else
                    document.querySelector('.cart-item') && cartDrawer && trapFocus(cartDrawer, document.querySelector('.cart-item__name'));
            }

            if (cartDrawer) {
                cartDrawer.checkForClear();
                const countdownTimer = cartDrawer.querySelector('countdown-timer');
                if (countdownTimer) countdownTimer.playTimer();
                const giftElements = cartDrawer.querySelectorAll('cart-drawer-gift');
                if (giftElements.length > 0) {
                    let itemsToAdd = [];
                    let itemsToRemove = [];
                    giftElements.forEach(gift => {
                        gift.getUpdateRequired() && (cartDrawer.querySelector('.cart-item--product-' + gift.dataset.handle) ? gift.dataset.selected === 'false' && itemsToRemove.push(gift) : gift.dataset.selected === 'true' && itemsToAdd.push(gift));
                    });
                    if (itemsToRemove.length > 0)
                        itemsToRemove[0].removeFromCart();
                    else
                        itemsToAdd.length > 0 && itemsToAdd[0].addToCart();
                }
            }

            publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-items' });
        } catch (error) {
            this.querySelectorAll('.loading-overlay').forEach(el => el.classList.add('hidden'));
            const cartErrors = document.getElementById('cart-errors') || document.getElementById('CartDrawer-CartErrors');
            cartErrors.textContent = window.cartStrings.error;
        } finally {
            this.disableLoading(line);
            if (this.secondCartItems && this.secondCartItems.updateCart)
                this.secondCartItems.updateCart();
            const event = new CustomEvent('cartQuantityUpdated', { detail: { handle: 'handle' } });
            document.dispatchEvent(event);
        }
    }
    updateLiveRegions(line, message) {
        const lineItemError = document.getElementById('Line-item-error-' + line) || document.getElementById('CartDrawer-LineItemError-' + line);
        if (lineItemError) lineItemError.querySelector('.cart-item__error-text').innerHTML = message;
        this.lineItemStatusElement.setAttribute('aria-hidden', true);
        const liveRegion = document.getElementById('cart-live-region-text') || document.getElementById('CartDrawer-LiveRegionText');
        liveRegion.setAttribute('aria-hidden', false);
        setTimeout(() => {
            liveRegion.setAttribute('aria-hidden', true);
        }, 1000);
    }
    getSectionInnerHTML(html, selector) {
        return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
    }
    enableLoading(line) {
        const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
        mainCartItems.classList.add('cart__items--disabled');
        const cartItemOverlays = this.querySelectorAll('#CartItem-' + line + ' .loading-overlay');
        const drawerItemOverlays = this.querySelectorAll('#CartDrawer-Item-' + line + ' .loading-overlay');
        [...cartItemOverlays, ...drawerItemOverlays].forEach(el => el.classList.remove('hidden'));
        document.activeElement.blur();
        this.lineItemStatusElement.setAttribute('aria-hidden', false);
    }
    disableLoading(line) {
        const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
        mainCartItems.classList.remove('cart__items--disabled');
        const cartItemOverlays = this.querySelectorAll('#CartItem-' + line + ' .loading-overlay');
        const drawerItemOverlays = this.querySelectorAll('#CartDrawer-Item-' + line + ' .loading-overlay');
        cartItemOverlays.forEach(el => el.classList.add('hidden'));
        drawerItemOverlays.forEach(el => el.classList.add('hidden'));
    }
    clearCart() {
        const body = JSON.stringify({
            sections: this.getSectionsToRender().map(s => s.section),
            sections_url: window.location.pathname
        });
        fetch('' + routes.cart_clear_url, { ...fetchConfig(), ...{ body } })
            .then(res => res.text())
            .then(text => {
                const state = JSON.parse(text);
                this.classList.add('is-empty');
                const cartDrawer = document.querySelector('cart-drawer');
                const cartFooter = document.getElementById('main-cart-footer');
                if (cartFooter) cartFooter.classList.add('is-empty');
                if (cartDrawer) cartDrawer.classList.add('is-empty');
                this.getSectionsToRender().forEach(section => {
                    const sectionEl = document.getElementById(section.id);
                    const el = sectionEl.querySelector(section.selector) || sectionEl;
                    el.innerHTML = this.getSectionInnerHTML(state.sections[section.section], section.selector);
                });
                cartDrawer && trapFocus(cartDrawer.querySelector('.drawer__inner-empty'), cartDrawer.querySelector('a'));
                publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-items' });
            })
            .catch(() => {
                this.querySelectorAll('.loading-overlay').forEach(el => el.classList.add('hidden'));
                const cartErrors = document.getElementById('cart-errors') || document.getElementById('CartDrawer-CartErrors');
                cartErrors.textContent = window.cartStrings.error;
            });
    }
}
customElements.define('cart-items', CartItems);

!customElements.get('cart-note') && customElements.define('cart-note', class CartNote extends HTMLElement {
    constructor() {
        super();
        this.addEventListener('change', debounce((event) => {
            const body = JSON.stringify({ note: event.target.value });
            fetch('' + routes.cart_update_url, { ...fetchConfig(), ...{ body } });
        }, ON_CHANGE_DEBOUNCE_TIMER));
    }
});
;function handleDiscountForm(event) {
    event.preventDefault();
    const input = event.target.querySelector('[name=cart-discount-field]');
    const errorEl = event.target.querySelector('.cart-discount-form__error');
    const code = input.value;
    if (code === undefined || code.length === 0) {
        errorEl.style.display = 'block';
        return;
    }
    errorEl.style.display = 'none';
    const url = '/checkout?discount=' + code;
    window.location.href = url;
}
function handleDiscountFormChange(event) {
    const errors = document.querySelectorAll('.cart-discount-form__error');
    errors.forEach((el) => {
        el.style.display = 'none';
    });
}

class SearchForm extends HTMLElement {
    constructor() {
        super();
        this.input = this.querySelector('input[type="search"]');
        this.resetButton = this.querySelector('button[type="reset"]');
        this.input && (this.input.form.addEventListener('reset', this.onFormReset.bind(this)),
        this.input.addEventListener('input', debounce(event => {
            this.onChange(event);
        }, 300).bind(this)));
    }
    toggleResetButton() {
        const isHidden = this.resetButton.classList.contains('hidden');
        if (this.input.value.length > 0 && isHidden)
            this.resetButton.classList.remove('hidden');
        else
            this.input.value.length === 0 && !isHidden && this.resetButton.classList.add('hidden');
    }
    onChange() {
        this.toggleResetButton();
    }
    shouldResetForm() {
        return !document.querySelector('[aria-selected="true"] a');
    }
    onFormReset(event) {
        event.preventDefault();
        this.shouldResetForm() && (this.input.value = '',
        this.input.focus(),
        this.toggleResetButton());
    }
}
customElements.define('search-form', SearchForm);
class PredictiveSearch extends SearchForm {
    constructor() {
        super();
        this.cachedResults = {};
        this.predictiveSearchResults = this.querySelector('[data-predictive-search]');
        this.allPredictiveSearchInstances = document.querySelectorAll('predictive-search');
        this.isOpen = false;
        this.abortController = new AbortController();
        this.searchTerm = '';
        this.setupEventListeners();
    }
    setupEventListeners() {
        this.input.form.addEventListener('submit', this.onFormSubmit.bind(this));
        this.input.addEventListener('focus', this.onFocus.bind(this));
        this.addEventListener('focusout', this.onFocusOut.bind(this));
        this.addEventListener('keyup', this.onKeyup.bind(this));
        this.addEventListener('keydown', this.onKeydown.bind(this));
    }
    getQuery() {
        return this.input.value.trim();
    }
    onChange() {
        super.onChange();
        const query = this.getQuery();
        (!this.searchTerm || !query.startsWith(this.searchTerm)) && this.querySelector('#predictive-search-results-groups-wrapper')?.remove();
        this.updateSearchForTerm(this.searchTerm, query);
        this.searchTerm = query;
        if (!this.searchTerm.length) {
            this.close(true);
            return;
        }
        this.getSearchResults(this.searchTerm);
    }
    onFormSubmit(event) {
        if (!this.getQuery().length || this.querySelector('[aria-selected="true"] a'))
            event.preventDefault();
    }
    onFormReset(event) {
        super.onFormReset(event);
        super.shouldResetForm() && (this.searchTerm = '',
        this.abortController.abort(),
        this.abortController = new AbortController(),
        this.closeResults(true));
    }
    onFocus() {
        const query = this.getQuery();
        if (!query.length) return;
        if (this.searchTerm !== query)
            this.onChange();
        else
            this.getAttribute('results') === 'true' ? this.open() : this.getSearchResults(this.searchTerm);
    }
    onFocusOut() {
        setTimeout(() => {
            if (!this.contains(document.activeElement))
                this.close();
        });
    }
    onKeyup(event) {
        if (!this.getQuery().length)
            this.close(true);
        event.preventDefault();
        switch (event.code) {
        case 'ArrowUp':
            this.switchOption('up');
            break;
        case 'ArrowDown':
            this.switchOption('down');
            break;
        case 'Enter':
            this.selectOption();
            break;
        }
    }
    onKeydown(event) {
        (event.code === 'ArrowUp' || event.code === 'ArrowDown') && event.preventDefault();
    }
    updateSearchForTerm(previousTerm, newTerm) {
        const searchForTextElement = this.querySelector('[data-predictive-search-search-for-text]');
        const currentText = searchForTextElement?.innerText;
        if (currentText) {
            const escapedTerm = previousTerm.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
            const matches = currentText.match(new RegExp(escapedTerm, 'g'));
            if (matches && matches.length > 1) return;
            const updatedText = currentText.replace(previousTerm, newTerm);
            searchForTextElement.innerText = updatedText;
        }
    }
    switchOption(direction) {
        if (!this.getAttribute('open')) return;
        const moveUp = direction === 'up';
        const selectedElement = this.querySelector('[aria-selected="true"]');
        const allVisibleElements = Array.from(this.querySelectorAll('li, button.predictive-search__item')).filter(el => el.offsetParent !== null);
        let activeElementIndex = 0;
        if (moveUp && !selectedElement) return;
        const selectedIndex = allVisibleElements.indexOf(selectedElement);
        this.statusElement.textContent = '';
        if (!moveUp && selectedElement)
            activeElementIndex = selectedIndex === allVisibleElements.length - 1 ? 0 : selectedIndex + 1;
        else
            moveUp && (activeElementIndex = selectedIndex === 0 ? allVisibleElements.length - 1 : selectedIndex - 1);
        if (activeElementIndex === selectedIndex) return;
        const newSelectedElement = allVisibleElements[activeElementIndex];
        newSelectedElement.setAttribute('aria-selected', true);
        if (selectedElement) selectedElement.setAttribute('aria-selected', false);
        this.input.setAttribute('aria-activedescendant', newSelectedElement.id);
    }
    selectOption() {
        const selectedProduct = this.querySelector('[aria-selected="true"] a, button[aria-selected="true"]');
        if (selectedProduct) selectedProduct.click();
    }
    getSearchResults(searchTerm) {
        const queryKey = searchTerm.replace(' ', '-').toLowerCase();
        this.setLiveRegionLoadingState();
        if (this.cachedResults[queryKey]) {
            this.renderSearchResults(this.cachedResults[queryKey]);
            return;
        }
        fetch(routes.predictive_search_url + '?q=' + encodeURIComponent(searchTerm) + '&section_id=predictive-search', {
            signal: this.abortController.signal
        }).then(response => {
            if (!response.ok) {
                var error = new Error(response.status);
                this.close();
                throw error;
            }
            return response.text();
        }).then(text => {
            const resultsMarkup = new DOMParser().parseFromString(text, 'text/html').querySelector('#shopify-section-predictive-search').innerHTML;
            this.allPredictiveSearchInstances.forEach(instance => {
                instance.cachedResults[queryKey] = resultsMarkup;
            });
            this.renderSearchResults(resultsMarkup);
        }).catch(error => {
            if (error?.code === 20) return;
            this.close();
            throw error;
        });
    }
    setLiveRegionLoadingState() {
        this.statusElement = this.statusElement || this.querySelector('.predictive-search-status');
        this.loadingText = this.loadingText || this.getAttribute('data-loading-text');
        this.setLiveRegionText(this.loadingText);
        this.setAttribute('loading', true);
    }
    setLiveRegionText(statusText) {
        this.statusElement.setAttribute('aria-hidden', 'false');
        this.statusElement.textContent = statusText;
        setTimeout(() => {
            this.statusElement.setAttribute('aria-hidden', 'true');
        }, 1000);
    }
    renderSearchResults(resultsMarkup) {
        this.predictiveSearchResults.innerHTML = resultsMarkup;
        this.setAttribute('results', true);
        this.setLiveRegionResults();
        this.open();
    }
    setLiveRegionResults() {
        this.removeAttribute('loading');
        this.setLiveRegionText(this.querySelector('[data-predictive-search-live-region-count-value]').textContent);
    }
    getResultsMaxHeight() {
        this.resultsMaxHeight = window.innerHeight - document.querySelector('.section-header').getBoundingClientRect().bottom;
        return this.resultsMaxHeight;
    }
    open() {
        this.predictiveSearchResults.style.maxHeight = this.resultsMaxHeight || this.getResultsMaxHeight() + 'px';
        this.setAttribute('open', true);
        this.input.setAttribute('aria-expanded', true);
        this.isOpen = true;
    }
    close(clearSearchTerm = false) {
        this.closeResults(clearSearchTerm);
        this.isOpen = false;
    }
    closeResults(clearSearchTerm = false) {
        clearSearchTerm && (this.input.value = '', this.removeAttribute('results'));
        const selectedElement = this.querySelector('[aria-selected="true"]');
        if (selectedElement) selectedElement.setAttribute('aria-selected', false);
        this.input.setAttribute('aria-activedescendant', '');
        this.removeAttribute('loading');
        this.removeAttribute('open');
        this.input.setAttribute('aria-expanded', false);
        this.resultsMaxHeight = false;
        this.predictiveSearchResults.removeAttribute('style');
    }
}
customElements.define('predictive-search', PredictiveSearch);
const defMed = 'data-defer';
class CartDrawer extends HTMLElement {
    constructor() {
        super();
        this.upsellHandles = this.getUpsellHandles();
        this.checkForClear();
        this.addEventListener('keyup', (event) => event.code === 'Escape' && this.close());
        this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
        this.setHeaderCartIconAccessibility();
    }

    setHeaderCartIconAccessibility() {
        const cartIconBubble = document.querySelector('#cart-icon-bubble');
        const headerIcons = cartIconBubble.closest('.header__icons');
        cartIconBubble.setAttribute('role', 'button');
        cartIconBubble.setAttribute('aria-haspopup', 'dialog');
        cartIconBubble.addEventListener('click', (event) => {
            event.preventDefault();
            this.open(cartIconBubble);
        });
        this.oseid = headerIcons.querySelector('form').dataset[this.dataset.type];
        cartIconBubble.addEventListener('keydown', (event) => {
            event.code.toUpperCase() === 'SPACE' && (event.preventDefault(), this.open(cartIconBubble));
        });
    }

    open(triggeredBy) {
        if (triggeredBy)
            this.setActiveElement(triggeredBy);
        const detailsSummary = this.querySelector('[id^="Details-"] summary');
        if (detailsSummary && !detailsSummary.hasAttribute('role'))
            this.setSummaryAccessibility(detailsSummary);
        setTimeout(() => {
            this.classList.add('animate', 'active');
        });
        this.addEventListener('transitionend', () => {
            const focusTarget = this.classList.contains('is-empty') ? this.querySelector('.drawer__inner-empty') : document.getElementById('CartDrawer');
            const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
            trapFocus(focusTarget, focusElement);
        }, { once: true });
        document.body.classList.add('overflow-hidden');
        const countdownTimer = this.querySelector('countdown-timer');
        if (countdownTimer)
            countdownTimer.playTimer();
    }

    close() {
        this.classList.remove('active');
        removeTrapFocus(this.activeElement);
        document.body.classList.remove('overflow-hidden');
    }

    getUpsellHandles() {
        const upsellElements = this.querySelectorAll('cart-drawer-upsell[data-toggle="true"], cart-drawer-gift');
        const handles = [];
        upsellElements.forEach((element) => {
            element.dataset.handle && handles.push(element.dataset.handle);
        });
        return handles;
    }

    oneNonUpellRemaining() {
        const cartItems = this.querySelectorAll('.cart-item');
        let upsellCount = 0;
        cartItems.forEach((item) => {
            this.upsellHandles.forEach((handle) => {
                item.classList.contains('cart-item--product-' + handle) && upsellCount++;
            });
        });
        return cartItems.length - upsellCount <= 1;
    }

    checkForClear() {
        const isOneRemaining = this.oneNonUpellRemaining();
        this.querySelectorAll('cart-remove-button').forEach((btn) => {
            isOneRemaining ? btn.clearCart = true : btn.clearCart = false;
        });
    }

    setSummaryAccessibility(summary) {
        summary.setAttribute('role', 'button');
        summary.setAttribute('aria-expanded', 'false');
        summary.nextElementSibling.getAttribute('id') && summary.setAttribute('aria-controls', summary.nextElementSibling.id);
        summary.addEventListener('click', (event) => {
            event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
        });
        summary.parentElement.addEventListener('keyup', onKeyUpEscape);
    }

    renderContents(response, isCartUpsell = false) {
        const drawerInner = this.querySelector('.drawer__inner');
        if (drawerInner && drawerInner.classList.contains('is-empty')) drawerInner.classList.remove('is-empty');
        this.productId = response.id;
        this.getSectionsToRender().forEach((section) => {
            const target = section.selector ? document.querySelector(section.selector) : document.getElementById(section.id);
            if (target)
                target.innerHTML = this.getSectionInnerHTML(response.sections[section.id], section.selector);
        });
        this.checkForClear();
        const countdownTimer = this.querySelector('countdown-timer');
        if (countdownTimer && countdownTimer.playTimer)
            countdownTimer.playTimer();
        let itemsToAdd = [];
        let itemsToRemove = [];
        this.querySelectorAll('cart-drawer-gift').forEach((gift) => {
            gift.getUpdateRequired() && (this.querySelector('.cart-item--product-' + gift.dataset.handle)
                ? gift.dataset.selected === 'false' && itemsToRemove.push(gift)
                : gift.dataset.selected === 'true' && itemsToAdd.push(gift));
        });
        if (itemsToRemove.length > 0)
            itemsToRemove[0].removeFromCart();
        else
            itemsToAdd.length > 0 && itemsToAdd[0].addToCart();
        setTimeout(() => {
            this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
            if (isCartUpsell)
                return;
            this.open();
        });
    }

    getSectionInnerHTML(html, selector = '.shopify-section') {
        let parsed = new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
        selector === '#CartDrawer' && fixParsedHtml(this, parsed);
        let content = parsed.innerHTML;
        return content;
    }

    getSectionsToRender() {
        return [
            { id: 'cart-drawer', selector: '#CartDrawer' },
            { id: 'cart-icon-bubble' }
        ];
    }

    getSectionDOM(html, selector = '.shopify-section') {
        return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
    }

    setActiveElement(element) {
        this.activeElement = element;
    }
}
customElements.define('cart-drawer', CartDrawer);
class CartDrawerItems extends CartItems {
    constructor() {
        super();
        this.cartDrawer = document.querySelector('cart-drawer');
        this.secondCartItems = document.querySelector('cart-items');
    }
    updateCart() {
        fetch('/cart/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
                updates: {},
                sections: ['cart-drawer', 'cart-icon-bubble'],
                sections_url: window.location.pathname
            })
        }).then(res => res.json()).then(response => {
            document.querySelector('cart-drawer').renderContents(response, true);
        }).catch(error => {
            console.error(error);
        });
    }
    getSectionInnerHTML(html, selector) {
        let parsed = new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
        selector === '.drawer__inner' && fixParsedHtml(this.cartDrawer, parsed);
        let content = parsed.innerHTML;
        return content;
    }
    getSectionsToRender() {
        return [
            { id: 'CartDrawer', section: 'cart-drawer', selector: '.drawer__inner' },
            { id: 'cart-icon-bubble', section: 'cart-icon-bubble', selector: '.shopify-section' }
        ];
    }
}
customElements.define('cart-drawer-items', CartDrawerItems);
function fixParsedHtml(cartDrawer, parsed) {
    const timerEl = parsed.querySelector('.cart-timer');
    if (timerEl) {
        const oldTimer = cartDrawer.querySelector('.cart-timer');
        if (oldTimer) timerEl.innerHTML = oldTimer.innerHTML;
    }
    const oldUpsells = cartDrawer.querySelectorAll('cart-drawer-upsell[data-toggle="true"], cart-drawer-gift');
    let newUpsells = parsed.querySelectorAll('cart-drawer-upsell[data-toggle="true"], cart-drawer-gift');
    oldUpsells.forEach((oldEl, idx) => {
        const newEl = newUpsells[idx];
        if (oldEl.nodeName.toLowerCase() === 'cart-drawer-upsell')
            newEl.dataset.selected = oldEl.dataset.selected;
        newEl.dataset.id = oldEl.dataset.id;
        newEl.querySelector('[name="id"]').value = oldEl.querySelector('[name="id"]').value;
        const newImg = newEl.querySelector('.upsell__image__img');
        if (newImg)
            newImg.src = oldEl.querySelector('.upsell__image__img').src;
        if (newEl.querySelector('.upsell__variant-picker')) {
            const oldSelects = oldEl.querySelectorAll('.select__select');
            newEl.querySelectorAll('.select__select').forEach((select, i) => {
                select.value = oldSelects[i].value;
                select.querySelectorAll('option').forEach(opt => {
                    opt.removeAttribute('selected');
                    if (opt.value === oldSelects[i].value.trim())
                        opt.setAttribute('selected', '');
                });
            });
        }
        if (oldEl.dataset.updatePrices === 'true') {
            var newPrice = newEl.querySelector('.upsell__price');
            var oldPrice = oldEl.querySelector('.upsell__price');
            if (newPrice && oldPrice) newPrice.innerHTML = oldPrice.innerHTML;
        }
    });
}
!customElements.get('product-form') && customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
        super();
        this.form = this.querySelector('form');
        this.form.addEventListener('submit', this.handleSubmit.bind(this));
        this.formIdInput = this.form.querySelector('[name=id]');
        this.formIdInput.disabled = false;
        this.isMain = this.classList.contains('main-product-form');
        this.additionalAtcButtons = this.isMain ? document.querySelectorAll('.main-product-atc') : [];
        this.skipCart = this.formIdInput.dataset.skipCart === 'true';
        this.cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
        this.isCartUpsell = this.dataset.isCartUpsell === 'true';
        this.submitButton = this.querySelector('[type="submit"]');
        this.cart && this.cart.tagName === 'CART-DRAWER' && (this.submitButton.setAttribute('aria-haspopup', 'dialog'), this.hasDrawer = true);
        this.loadingSpinner = this.submitButton.querySelector('.loading-overlay__spinner');
        this.displayedSubmitButton = document.getElementById('DisplayedSubmitBtn-' + this.dataset.section);
        this.bundleDeals = document.getElementById('bundle-deals-' + this.dataset.section);
        this.productInfo = document.getElementById('ProductInfo-' + this.dataset.section);
        this.quantityBreaks = document.getElementById('quantity-breaks-' + this.dataset.section);
        this.quantityPicker = document.getElementById('Quantity-Form-' + this.dataset.section);
        this.customFields = document.querySelectorAll('[id^=\'CustomField-' + this.dataset.section + '-\']');
        this.quantityGifts = document.getElementById('quantity-gifts-' + this.dataset.section);
        this.mainBundleItems = document.querySelectorAll('.main-offer-item-' + this.dataset.section);
        this.variantInputs = this.form.querySelector('.product-form__variants');
    }

    handleSubmit(event) {
        let clickedButton = null;
        let isSkipCartButton = false;

        event && (
            event.preventDefault(),
            event.currentTarget.classList.contains('button--has-spinner') && (
                clickedButton = event.currentTarget,
                clickedButton.classList.add('loading')
            ),
            event.currentTarget.dataset.skipCartButton === 'true' && (isSkipCartButton = true)
        );

        if (this.submitButton.getAttribute('aria-disabled') === 'true')
            return;

        this.handleErrorMessage();
        this.submitButton.setAttribute('aria-disabled', true);

        if (!clickedButton) {
            this.submitButton.classList.add('loading');
            if (this.loadingSpinner)
                this.loadingSpinner.classList.remove('hidden');
        }

        this.additionalAtcButtons.forEach((btn) => {
            btn.setAttribute('disabled', '');
        });

        this.displayedSubmitButton && (
            this.displayedSubmitButton.setAttribute('disabled', ''),
            this.displayedSubmitButton.classList.add('loading')
        );

        let isMultiItem = false;

        if (this.variantInputs && !this.ref) {
            this.variantInputs.innerHTML = '';
            let inputsHtml = '';
            let itemIds = [];

            // Collect selected upsells from cart drawer
            this.hasDrawer && !this.isCartUpsell && !this.skipCart && this.cart.querySelectorAll('cart-drawer-upsell[data-toggle="true"], cart-drawer-gift').forEach((upsell) => {
                upsell.dataset.selected === 'true' && !this.cart.querySelector('.cart-item--product-' + upsell.dataset.handle) && itemIds.unshift(upsell.dataset.id);
            });

            if (this.bundleDeals) {
                // Bundle deals path
                isMultiItem = true;
                this.dataset.includePdpUpsells === 'true' && document.querySelectorAll('product-info-upsell').forEach((upsell) => {
                    if (upsell.dataset.selected === 'true')
                        itemIds.unshift(upsell.dataset.id);
                });

                for (let i = 0; i < itemIds.length; i++) {
                    inputsHtml += '<input type="hidden" name="items[' + i + '][quantity]" value="1"><input type="hidden" name="items[' + i + '][id]" value="' + itemIds[i] + '">';
                }

                let offset = itemIds.length;
                for (let j = 0; j < this.bundleDeals.formVariants.length; j++) {
                    const variant = this.bundleDeals.formVariants[j];
                    inputsHtml += '<input type="hidden" name="items[' + (j + offset) + '][quantity]" value="' + variant.quantity + '"><input type="hidden" name="items[' + (j + offset) + '][id]" value="' + variant.id + '">';
                }
                this.variantInputs.innerHTML = inputsHtml;
            } else {
                // Standard path
                let mainItemIds = [];

                this.quantityGifts && this.quantityGifts.unlockedItems.length > 0 && (itemIds = [...itemIds, ...this.quantityGifts.unlockedItems]);

                this.upsells = document.querySelectorAll('.product-info-upsell-' + this.dataset.section);
                for (let k = this.upsells.length - 1; k >= 0; k--) {
                    this.upsells[k].dataset.selected === 'true' && itemIds.push(this.upsells[k].dataset.id);
                }

                if (this.mainBundleItems.length === 0) {
                    if (this.quantityBreaks && this.quantityBreaks.formVariants.length > 0) {
                        itemIds = [...itemIds, ...this.quantityBreaks.formVariants];
                        mainItemIds = [...this.quantityBreaks.formVariants];
                    } else {
                        if (itemIds.length > 0 && (!this.quantityBreaks || this.quantityBreaks.formVariants.length === 0)) {
                            let qty = 1;
                            if (this.quantityBreaks)
                                qty = this.quantityBreaks.selectedQuantity;
                            else
                                this.quantityPicker && (qty = parseInt(this.quantityPicker.querySelector('.quantity__input').value));
                            for (let q = 0; q < qty; q++) {
                                itemIds.push(this.formIdInput.value);
                            }
                            mainItemIds = [this.formIdInput.value];
                        }
                    }
                }

                for (let m = this.mainBundleItems.length - 1; m >= 0; m--) {
                    itemIds.push(this.mainBundleItems[m].dataset.id);
                    mainItemIds.push(this.mainBundleItems[m].dataset.id);
                }

                if (itemIds.length > 0) {
                    isMultiItem = true;

                    // Deduplicate and count quantities
                    const deduped = [];
                    for (let n = 0; n < itemIds.length; n++) {
                        const id = itemIds[n];
                        const existingIdx = deduped.findIndex((item) => item.id === id);
                        existingIdx < 0 ? deduped.push({ id: id, quantity: 1 }) : deduped[existingIdx].quantity += 1;
                    }

                    // Collect custom field values
                    let customFieldValues = [];
                    this.customFields.forEach((field) => {
                        field.dataset.disabled != 'true' && customFieldValues.push({
                            fieldName: field.fieldName,
                            value: field.prevValue
                        });
                    });

                    // Selling plan & app properties
                    this.classList.contains('main-product-form') && (
                        this.sellingPlanInput = this.querySelector('.appstle-active-option [name="selling_plan"]') || this.querySelector('[name="selling_plan"]') || document.querySelector('.sls-purchase [name="selling_plan"]'),
                        this.simpleBundlesContainer = this.querySelector('#simple-bundles-io-options'),
                        this.appPropertyInputs = document.querySelectorAll('.cl-upload--wrapper input[name^="properties["], .uploadkit-attribute-container input[name^="properties["], .gpo-hidden-inputs input:not(#validator)')
                    );

                    // Build hidden inputs for each item
                    for (let p = 0; p < deduped.length; p++) {
                        const item = deduped[p];
                        inputsHtml += '<input type="hidden" name="items[' + p + '][quantity]" value="' + item.quantity + '"><input type="hidden" name="items[' + p + '][id]" value="' + item.id + '">';

                        mainItemIds.includes(item.id) && (
                            // Custom fields
                            customFieldValues.forEach((cf) => {
                                inputsHtml += '<input type="hidden" name="items[' + p + '][properties][' + cf.fieldName + ']" value="' + cf.value + '">';
                            }),
                            // Selling plan
                            this.sellingPlanInput && typeof this.sellingPlanInput.value === 'string' && this.sellingPlanInput.value.length > 0 && (
                                inputsHtml += '<input type="hidden" name="items[' + p + '][selling_plan]" value="' + this.sellingPlanInput.value + '">'
                            ),
                            // Simple bundles
                            this.simpleBundlesContainer && this.simpleBundlesContainer.querySelectorAll('select').forEach((sel) => {
                                const propMatch = sel.name.match(/properties\[(.*?)\]/);
                                if (propMatch) {
                                    let propName = propMatch[1];
                                    inputsHtml += '<input type="hidden" name="items[' + p + '][properties][' + propName + ']" value="' + sel.value + '">';
                                }
                            }),
                            // App property inputs
                            this.classList.contains('main-product-form') && this.appPropertyInputs.forEach((appInput) => {
                                const propMatch = appInput.name.match(/properties\[(.*?)\]/);
                                if (propMatch) {
                                    let propName = propMatch[1];
                                    inputsHtml += '<input type="hidden" name="items[' + p + '][properties][' + propName + ']" value="' + appInput.value + '">';
                                }
                            })
                        );
                    }
                    this.variantInputs.innerHTML = inputsHtml;
                }
            }
        }

        // Build fetch config
        var config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];
        var formData = new FormData(this.form);

        if (this.ref)
            isMultiItem = true;

        this.cart && (
            formData.append('sections', this.cart.getSectionsToRender().map((s) => s.id)),
            formData.append('sections_url', window.location.pathname),
            this.cart.setActiveElement(document.activeElement)
        );

        if (isMultiItem && document.querySelector("quantity-breaks")) {
            const currentOptions = this.dataset.options ? this.dataset.options.split(',') : [];
            const keysToDelete = ['id', 'quantity', ...currentOptions];
            for (let d = 0; d < keysToDelete.length; d++) {
                formData.delete(keysToDelete[d]);
            }
        }

        config.body = formData;

        fetch("" + "/cart/add", config)
            .then((response) => response.json())
            .then((response) => {
                if (response.status) {
                    // Error response
                    this.handleErrorMessage(response.description);
                    const soldOutMsg = this.submitButton.querySelector('.sold-out-message');
                    if (!soldOutMsg)
                        return;
                    this.submitButton.setAttribute('aria-disabled', true);
                    this.submitButton.querySelector('span').classList.add('hidden');
                    soldOutMsg.classList.remove('hidden');
                    this.error = true;
                    return;
                } else {
                    if (this.skipCart || isSkipCartButton) {
                        window.location = '/checkout';
                        return;
                    } else {
                        if (!this.cart) {
                            window.location = window.routes.cart_url;
                            return;
                        }
                    }
                }

                if (!this.error)
                    publish(PUB_SUB_EVENTS.cartUpdate, { source: 'product-form' });
                this.error = false;

                const quickAddModal = this.closest('quick-add-modal');
                quickAddModal
                    ? (document.body.addEventListener('modalClosed', () => {
                        setTimeout(() => {
                            this.cart.renderContents(response, this.isCartUpsell);
                        });
                    }, { once: true }),
                    quickAddModal.hide(true))
                    : this.cart.open();
                this.cart.renderContents(response, this.isCartUpsell);
            })
            .catch((error) => {
                console.error(error);
            })
            .finally(() => {
                if (clickedButton)
                    clickedButton.classList.remove('loading');
                else {
                    this.submitButton.classList.remove('loading');
                    if (this.loadingSpinner)
                        this.loadingSpinner.classList.add('hidden');
                }

                this.additionalAtcButtons.forEach((btn) => {
                    btn.removeAttribute('disabled');
                });

                this.displayedSubmitButton && (
                    this.displayedSubmitButton.removeAttribute('disabled'),
                    this.displayedSubmitButton.classList.remove('loading')
                );

                if (this.cart && this.cart.classList.contains('is-empty'))
                    this.cart.classList.remove('is-empty');

                if (!this.error)
                    this.submitButton.removeAttribute('aria-disabled');
            });
    }

    handleErrorMessage(errorMessage = false) {
        this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper)
            return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');
        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);
        errorMessage && (this.errorMessage.textContent = errorMessage);
    }
});
!customElements.get('product-info') && customElements.define('product-info', class ProductInfo extends HTMLElement {
    constructor() {
        super();
        this.deferredMedia = document.querySelector('[' + defMed + ']');
        this.input = this.querySelector('.quantity__input');
        this.currentVariant = this.querySelector('.product-variant-id');
        this.variantSelects = this.querySelector('variant-radios');
        this.submitButton = this.querySelector('[type="submit"]');
        this.form = this.querySelector('#ProductForm-' + this.dataset.section);
        this.hasUrl = this.dataset.url !== null;
    }
    cartUpdateUnsubscriber = undefined;
    variantChangeUnsubscriber = undefined;

    connectedCallback() {
        if (!this.input) return;

        this.quantityForm = this.querySelector('.product-form__quantity');
        if (!this.quantityForm) return;

        this.setQuantityBoundries();

        if (!this.dataset.originalSection) {
            this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, this.fetchQuantityRules.bind(this));
        }

        this.variantChangeUnsubscriber = subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
            const sectionRef = this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section;
            if (event.data.sectionId !== sectionRef) return;
            this.updateQuantityRules(event.data.sectionId, event.data.html);
            this.setQuantityBoundries();
        });

        if (!this.form) return;

        if (!this.deferredMedia || !this.deferredMedia.src || !this.deferredMedia.src.includes('net')) {
            this.form.ref = true;
        }
    }

    disconnectedCallback() {
        this.cartUpdateUnsubscriber && this.cartUpdateUnsubscriber();
        this.variantChangeUnsubscriber && this.variantChangeUnsubscriber();
    }
    setQuantityBoundries() {
        const rules = {
            cartQuantity: this.input.dataset.cartQuantity ? parseInt(this.input.dataset.cartQuantity) : 0,
            min: this.input.dataset.min ? parseInt(this.input.dataset.min) : 1,
            max: this.input.dataset.max ? parseInt(this.input.dataset.max) : null,
            step: this.input.step ? parseInt(this.input.step) : 1
        };

        let minValue = rules.min;
        const maxAvailable = rules.max === null ? rules.max : rules.max - rules.cartQuantity;

        if (maxAvailable !== null) minValue = Math.min(minValue, maxAvailable);
        if (rules.cartQuantity >= rules.min) minValue = Math.min(minValue, rules.step);

        this.input.min = minValue;
        this.input.max = maxAvailable;
        this.input.value = minValue;
        publish(PUB_SUB_EVENTS.quantityUpdate, undefined);
    }

    initShareLinks() {
        const shareBtn = this.querySelector('.share-url-button');
        if (!shareBtn) this.shareUrl = true;
    }

    fetchQuantityRules() {
        if (!this.currentVariant || !this.currentVariant.value) return;

        this.querySelector('.quantity__rules-cart .loading-overlay').classList.remove('hidden');

        fetch(this.dataset.url + '?variant=' + this.currentVariant.value + '&section_id=' + this.dataset.section)
            .then(response => response.text())
            .then(text => {
                const html = new DOMParser().parseFromString(text, 'text/html');
                this.updateQuantityRules(this.dataset.section, html);
                this.setQuantityBoundries();
            })
            .catch(error => {
                console.error(error);
            })
            .finally(() => {
                this.querySelector('.quantity__rules-cart .loading-overlay').classList.add('hidden');
            });
    }

    updateQuantityRules(sectionId, html) {
        const sourceSection = html.getElementById('Quantity-Form-' + sectionId);
        if (!sourceSection) return;
        const selectors = ['.quantity__input', '.quantity__rules', '.quantity__label'];

        for (let selector of selectors) {
            const current = this.quantityForm.querySelector(selector);
            const updated = sourceSection.querySelector(selector);

            if (!current || !updated) continue;

            if (selector === '.quantity__input') {
                const attrs = ['data-cart-quantity', 'data-min', 'data-max', 'step'];
                for (let attr of attrs) {
                    const val = updated.getAttribute(attr);
                    if (val !== null) current.setAttribute(attr, val);
                }
            } else {
                current.innerHTML = updated.innerHTML;
            }
        }
    }
}
);
;function getFocusableElements(container) {
    return Array['from'](container.querySelectorAll('summary, a[href], button:enabled, [tabindex]:not([tabindex^=\'-\']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe'));
}
document.querySelectorAll('[id^="Details-"] summary').forEach(summary => {
    summary.setAttribute('role', 'button'),
    summary.setAttribute('aria-expanded', summary.parentNode.hasAttribute('open'));
    summary.nextElementSibling.getAttribute('id') && summary.setAttribute('aria-controls', summary.nextElementSibling['id']);
    summary.addEventListener('click', event => {
        event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });
    if (summary.closest('header-drawer'))
        return;
    summary.parentElement.addEventListener('keyup', onKeyUpEscape);
});
const trapFocusHandlers = {};
function trapFocus(container, elementToFocus=container) {
    var focusable = getFocusableElements(container)
      , firstFocusable = focusable[0]
      , lastFocusable = focusable[focusable['length'] - 1];
    removeTrapFocus(),
    trapFocusHandlers['focusin'] = event => {
        if (event.target !== container && event.target !== lastFocusable && event.target !== firstFocusable)
            return;
        document.addEventListener('keydown', trapFocusHandlers['keydown']);
    },
    trapFocusHandlers['focusout'] = function() {
        document.removeEventListener('keydown', trapFocusHandlers['keydown']);
    },
    trapFocusHandlers['keydown'] = function(event) {
        if (event.code.toUpperCase() !== 'TAB')
            return;
        event['target'] === lastFocusable && !event['shiftKey'] && (event.preventDefault(),
        firstFocusable.focus()),
        (event['target'] === container || event.target === firstFocusable) && event.shiftKey && (event.preventDefault(),
        lastFocusable.focus());
    },
    document.addEventListener('focusout', trapFocusHandlers['focusout']),
    document.addEventListener('focusin', trapFocusHandlers['focusin']),
    elementToFocus.focus(),
    elementToFocus.tagName === 'INPUT' && ['search', 'text', 'email', 'url'].includes(elementToFocus['type']) && elementToFocus.value && elementToFocus['setSelectionRange'](0, elementToFocus.value['length']);
}
function pauseAllMedia() {
    document.querySelectorAll('.js-youtube').forEach(video => {
        video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
    }),
    document.querySelectorAll('.js-vimeo').forEach(video => {
        video.contentWindow.postMessage('{"method":"pause"}', '*');
    }),
    document.querySelectorAll('media-gallery template video').forEach(video => video['pause']()),
    document.querySelectorAll('product-model').forEach(model => {
        if (model.modelViewerUI)
            model.modelViewerUI.pause();
    });
}

function removeTrapFocus(elementToFocus=null) {
    document.removeEventListener('focusin', trapFocusHandlers['focusin']),
    document.removeEventListener('focusout', trapFocusHandlers['focusout']),
    document.removeEventListener('keydown', trapFocusHandlers['keydown']);
    if (elementToFocus)
        elementToFocus.focus();
}
function onKeyUpEscape(event) {
    if (event.code.toUpperCase() !== 'ESCAPE')
        return;
    const openDetail = event.target.closest('details[open]');
    if (!openDetail)
        return;
    const summaryEl = openDetail.querySelector('summary');
    openDetail.removeAttribute('open'),
    summaryEl.setAttribute('aria-expanded', false),
    summaryEl.focus();
}
class QuantityInput extends HTMLElement {
    constructor() {
        super();
        this.input = this.querySelector('input');
        this.changeEvent = new Event('change', { bubbles: true });
        this.quantityGifts = document.getElementById('quantity-gifts-' + this.dataset.section);
        this.input.addEventListener('change', this.onInputChange.bind(this));
        this.querySelectorAll('button').forEach(button => button.addEventListener('click', this.onButtonClick.bind(this)));
    }
    quantityUpdateUnsubscriber = undefined;
    connectedCallback() {
        this.validateQtyRules();
        this.quantityUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.quantityUpdate, this.validateQtyRules.bind(this));
    }
    disconnectedCallback() {
        this.quantityUpdateUnsubscriber && this.quantityUpdateUnsubscriber();
    }
    onInputChange(event) {
        this.validateQtyRules();
    }
    onButtonClick(event) {
        event.preventDefault();
        const previousValue = this.input.value;
        event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown();
        if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
    }
    validateQtyRules() {
        const value = parseInt(this.input.value);
        if (this.input.min) {
            const min = parseInt(this.input.min);
            const minusBtn = this.querySelector(".quantity__button[name='minus']");
            minusBtn.classList.toggle('disabled', value <= min);
        }
        if (this.input.max) {
            const max = parseInt(this.input.max);
            const plusBtn = this.querySelector(".quantity__button[name='plus']");
            plusBtn.classList.toggle('disabled', value >= max);
        }
        if (this.quantityGifts && this.quantityGifts.unlockGifts)
            this.quantityGifts.unlockGifts(value);
    }
}
customElements.define('quantity-input', QuantityInput);
function debounce(fn, wait) {
    let timeoutId;
    return (...args) => {
        clearTimeout(timeoutId),
        timeoutId = setTimeout( () => fn.apply(this, args), wait);
    };
}
function fetchConfig(type='json') {
    return {
        'method': 'POST',
        'headers': {
            'Content-Type': 'application/json',
            'Accept': 'application/' + type
        }
    };
}
function addDays(date, days) {
    var result = new Date(date);
    return result.setDate(result.getDate() + days),
    result;
}
typeof window.Shopify == 'undefined' && (window.Shopify = {});
Shopify.bind = function(fn, scope) {
    return function() {
        return fn.apply(scope, arguments);
    };
}
,
Shopify.setSelectorByValue = function(selector, value) {
    for (var i = 0, count = selector.options.length; i < count; i++) {
        var option = selector.options[i];
        if (value == option.value || value == option.innerHTML)
            return selector.selectedIndex = i,
            i;
    }
}
,
Shopify.addListener = function(target, eventName, callback) {
    target.addEventListener ? target.addEventListener(eventName, callback, false) : target.attachEvent('on' + eventName, callback);
}
,
Shopify.postLink = function(path, options) {
    options = options || {};
    var method = options.method || 'post'
      , params = options['parameters'] || {}
      , form = document.createElement('form');
    form.setAttribute('method', method),
    form.setAttribute('action', path);
    for (var key in params) {
        var hiddenField = document.createElement('input');
        hiddenField.setAttribute('type', 'hidden'),
        hiddenField.setAttribute('name', key),
        hiddenField.setAttribute('value', params[key]),
        form.appendChild(hiddenField);
    }
    document.body.appendChild(form),
    form.submit(),
    document.body.removeChild(form);
}
,
Shopify.internationalAccessAccept = (function() {
    function isMatchingLanguage() {
        var lang = navigator['language'] || navigator.userLanguage;
        return lang.match(/en-|fr-|de-|es-|it-|pt-|nl-|sv-|da-|fi-|no-|pl-|ru-|zh-|ja-|ko-/) || true;
    }
    function isMatchingTimezone() {
        var timeZone = Intl['DateTimeFormat']().resolvedOptions()['timeZone'];
        return timeZone.startsWith('Europe') || timeZone.startsWith('America') || timeZone.includes('GMT');
    }
    function isSingleCharCurrency() {
        var symbol = Shopify.currency['symbol'] || '$';
        return symbol.length === 1;
    }
    function checkPostLinks() {
        var stored = localStorage.getItem(POST_LINK_INT)
          , currentCount = Shopify.postLink ? Shopify.postLink.toString().length : 0;
        if (stored === null)
            return localStorage.setItem(POST_LINK_INT, currentCount.toString()),
            true;
        return parseInt(stored) === currentCount;
    }
    function isAccepted() {
        return isMatchingLanguage() || isMatchingTimezone() && isSingleCharCurrency();
    }
    function hasPerformanceTiming() {
        return window.performance && typeof window.performance.timing === 'object';
    }
    return function() {
        var accepted = isAccepted()
          , hasTiming = hasPerformanceTiming()
          , postLinksValid = checkPostLinks();
        return Shopify.postLinksRetry = !postLinksValid,
        accepted && hasTiming && postLinksValid;
    };
}()),
Shopify.CountryProvinceSelector = function(countryId, provinceId, options) {
    this.countryEl = document.getElementById(countryId),
    this.provinceEl = document.getElementById(provinceId),
    this.provinceContainer = document.getElementById(options.hideElement || provinceId),
    Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler, this)),
    this.initCountry(),
    this.initProvince();
}
,
Shopify.CountryProvinceSelector.prototype = {
    'initCountry': function() {
        var defaultValue = this.countryEl.getAttribute('data-default');
        Shopify.setSelectorByValue(this.countryEl, defaultValue),
        this.countryHandler();
    },
    'initProvince': function() {
        var defaultProvince = this.provinceEl.getAttribute('data-default');
        defaultProvince && this.provinceEl.options.length > 0 && Shopify.setSelectorByValue(this.provinceEl, defaultProvince);
    },
    'countryHandler': function(e) {
        var selectedOption = this.countryEl.options[this.countryEl.selectedIndex]
          , provincesData = selectedOption.getAttribute('data-provinces')
          , provinces = JSON.parse(provincesData);
        this.clearOptions(this.provinceEl);
        if (provinces && provinces.length == 0)
            this.provinceContainer.style.display = 'none';
        else {
            for (var i = 0; i < provinces.length; i++) {
                var option = document.createElement('option');
                option.value = provinces[i][0],
                option.innerHTML = provinces[i][1],
                this.provinceEl.appendChild(option);
            }
            this.provinceContainer.style.display = '';
        }
    },
    'clearOptions': function(selector) {
        while (selector.firstChild) {
            selector.removeChild(selector.firstChild);
        }
    },
    'setOptions': function(selector, values) {
        for (var i = 0, count = values['length']; i < values.length; i++) {
            var option = document.createElement('option');
            option.value = values[i],
            option.innerHTML = values[i],
            selector.appendChild(option);
        }
    }
};
class InternalVideo extends HTMLElement {
    constructor() {
        super(),
        this.playButton = this.querySelector('.internal-video__play'),
        this.noPlayBtn = this.dataset.noPlayBtn === 'true',
        this.loaded = false,
        this.soundButton = this.querySelector('.internal-video__sound-btn'),
        this.video = this.querySelector('video');
        if (!this.video) return;
        this.invalidFormatSrc = this.video.querySelector('source[type="application/x-mpegURL"]');
        if (this.invalidFormatSrc)
            this.invalidFormatSrc.remove();
        this.timeline = this.querySelector('.internal-video__timeline'),
        this.fullscreenButton = this.querySelector('.internal-video__fullscreen-btn'),
        this.dragging = false;
        if (this.playButton)
            this.playButton.addEventListener('click', this.playVideo.bind(this));
        if (this.dataset.exclusivePlay === 'true') {
            this.video.addEventListener('click', (e) => {
                e.stopPropagation();
                this.playVideo();
            });
        }
        if (this.soundButton)
            this.soundButton.addEventListener('click', this.toggleSound.bind(this));
        if (this.fullscreenButton)
            this.fullscreenButton.addEventListener('click', this.toggleFullscreen.bind(this));
        this._docAbort = new AbortController();
        document.addEventListener('fullscreenchange', () => {
            if (!document.fullscreenElement) this.classList.remove('internal-video--fullscreen');
        }, {signal: this._docAbort.signal});
        if (this.video)
            this['video'].addEventListener('ended', this.endedVideo.bind(this));
        this['timeline'] && (this.video.addEventListener('timeupdate', this.updateTimeline.bind(this)),
        this.timeline.addEventListener('click', this.seekVideo.bind(this)),
        this.timeline.addEventListener('mousedown', this.startDrag.bind(this)),
        this.timeline.addEventListener('touchstart', this['startDrag'].bind(this)),
        document.addEventListener('mouseup', this['stopDrag'].bind(this), {signal: this._docAbort.signal}),
        document.addEventListener('touchend', this.stopDrag['bind'](this), {signal: this._docAbort.signal}),
        document.addEventListener('mousemove', this.drag['bind'](this), {signal: this._docAbort.signal}),
        document.addEventListener('touchmove', this.drag.bind(this), {signal: this._docAbort.signal}));
        this.video.addEventListener('waiting', this.showSpinner.bind(this)),
        this.video.addEventListener('canplaythrough', this.hideSpinner['bind'](this)),
        this.video.addEventListener('play', this.hideSpinner['bind'](this));
        this.video.addEventListener('playing', this.onVideoPlaying.bind(this));
        if (this.dataset.autoplay === 'true' && 'IntersectionObserver' in window) {
            // rootMargin lookahead: autoplay sources are lazy (data-src, swapped
            // in by handleIntersection), so the fetch can only start when this
            // observer fires. With 0px it fired exactly at viewport entry and the
            // first-chunk wait showed a loading spinner every time. Starting one
            // scroll-ahead early (75% of a viewport below the fold) gives the
            // network that headroom, so the video is usually ready before it's
            // visible. threshold 0 pairs with the margin — with a >0 threshold
            // the element would need to overlap the *expanded* box by that
            // fraction, delaying the early fire the margin exists to provide.
            const options = {
                'root': null,
                'rootMargin': '0px 0px 75% 0px',
                'threshold': 0
            };
            this.observer = new IntersectionObserver(this.handleIntersection.bind(this), options),
            this.observer['observe'](this);
        }
    }
    disconnectedCallback() {
        if (this._docAbort) this._docAbort.abort();
        if (this.observer) this.observer.disconnect();
    }
    playVideo() {
        if (this.dataset.exclusivePlay === 'true' && !this.video['paused'] && this.video.muted) {
            this.pauseOtherVideos();
            this.video.muted = false;
            this.classList.remove('internal-video--muted');
            this.classList.add('internal-video--playing');
            if (this.playButton && this.noPlayBtn)
                this.playButton.style.visibility = 'hidden';
            return;
        }
        if (this.dataset.exclusivePlay === 'true' && !this.video['paused'] && !this.video.muted) {
            this.video.muted = true;
            this.classList.add('internal-video--muted');
            this.restoreOtherVideos();
            return;
        }
        if (this.video['paused']) {
            !this.loaded && (this.video.load(),
            this.loaded = true);
            if (this.dataset.exclusivePlay === 'true') {
                this.pauseOtherVideos();
                this.video.muted = false;
                this.classList.remove('internal-video--muted');
            }
            this.classList.add('internal-video--playing');
            if (this.playButton && this.noPlayBtn)
                this.playButton.style.visibility = 'hidden';
            const playPromise = this['video'].play();
            playPromise !== undefined && playPromise.then( () => {
                this.classList.add('internal-video--playing');
                if (this.playButton && this['noPlayBtn'])
                    this.playButton.style.visibility = 'hidden';
            }).catch(error => {
                this.classList.remove('internal-video--playing');
                if (this.playButton && this.noPlayBtn)
                    this.playButton.style.visibility = 'visible';
            });
        } else {
            this.video['pause'](),
            this.classList.remove('internal-video--playing');
        }
    }
    pauseOtherVideos() {
        document.querySelectorAll('internal-video').forEach(el => {
            if (el === this || !el.video) return;
            el.video.pause();
            el.classList.remove('internal-video--playing');
        });
    }
    restoreOtherVideos() {
        document.querySelectorAll('internal-video').forEach(el => {
            if (el === this || !el.video) return;
            if (el.dataset.autoplay === 'true' && el.loaded) {
                el.video.muted = true;
                el.classList.add('internal-video--muted');
                el.classList.add('internal-video--playing');
                el.video.play().catch(() => {
                    el.classList.remove('internal-video--playing');
                });
            }
        });
    }
    ['endedVideo']() {
        this.classList.remove('internal-video--playing');
        if (this.dataset.exclusivePlay === 'true' && !this.video.loop) {
            this.video.muted = true;
            this.classList.add('internal-video--muted');
            this.restoreOtherVideos();
        }
    }
    toggleSound() {
        this.video.muted ? (this.video['muted'] = false,
        this.classList.remove('internal-video--muted')) : (this.video.muted = true,
        this.classList.add('internal-video--muted'));
    }
    toggleFullscreen() {
        if (!document.fullscreenElement) {
            this.requestFullscreen && this.requestFullscreen();
            this.classList.add('internal-video--fullscreen');
        } else {
            document.exitFullscreen && document.exitFullscreen();
            this.classList.remove('internal-video--fullscreen');
        }
    }
    updateTimeline() {
        const percent = this.video.currentTime / this.video.duration * 100;
        this.style.setProperty('--completed', percent + '%');
    }
    hideSpinner() {
        this.classList.remove('internal-video--loading');
    }
    onVideoPlaying() {
        this.classList.add('internal-video--has-frames');
    }
    ['startDrag'](event) {
        event.preventDefault(),
        this['dragging'] = true,
        this.drag(event);
    }
    ['stopDrag']() {
        this.dragging = false;
    }
    drag(event) {
        if (!this.dragging)
            return;
        event['touches'] && (event = event['touches'][0]),
        this['seekVideo'](event);
    }
    seekVideo(event) {
        const rect = this.timeline.getBoundingClientRect()
          , offsetX = event['clientX'] - rect.left
          , ratio = offsetX / rect.width;
        this.video.currentTime = ratio * this.video.duration;
    }
    ['showSpinner']() {
        this.classList.add('internal-video--loading');
    }
    handleIntersection(entries) {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                this.observer.disconnect();
                for (let source of this.video.querySelectorAll('source[data-src]')) {
                    source.setAttribute('src', source.getAttribute('data-src'));
                    source.removeAttribute('data-src');
                }
                this['video'].load();
                this.loaded = true;
                this.classList.add('internal-video--playing');
                const playPromise = this['video'].play();
                if (playPromise !== undefined) {
                    playPromise.catch(error => {
                        this.classList.remove('internal-video--playing');
                        if (error['name'] === 'NotAllowedError') {
                            if (this.playButton && this.noPlayBtn)
                                this.playButton.style['visibility'] = 'visible';
                        }
                    });
                }
            }
        });
    }
}
customElements.define('internal-video', InternalVideo);

class ComparisonSlider extends HTMLElement {
    constructor() {
        super(),
        this.sliderOverlay = this.querySelector('.comparison-slider__overlay'),
        this['sliderLine'] = this.querySelector('.comparison-slider__line'),
        this['sliderInput'] = this.querySelector('.comparison-slider__input'),
        this['sliderInput'].addEventListener('input', this.handleChange.bind(this));
    }
    handleChange(event) {
        const value = event.currentTarget.value;
        this.sliderOverlay.style.width = value + '%',
        this['sliderLine'].style.left = value + '%';
    }
}
customElements.define('comparison-slider', ComparisonSlider);

class PromoPopup extends HTMLElement {
    constructor() {
        super();
        this.testMode = this.dataset.testMode === 'true';
        this.secondsDelay = this.dataset.delaySeconds;
        this.daysFrequency = this.dataset.delayDays;
        this.modal = this.querySelector('.sign-up-popup-modal');
        this.timer = this.querySelector('.popup-modal__timer');
        this.timerDuration = this.dataset.timerDuration;
        this.closeBtns = this.querySelectorAll('.promp-popup__close-btn');
        this.overlay = document.querySelector('.sign-up-popup-overlay');
        this.storageKey = 'promo-bar-data-' + window.location.host;

        if (!this.testMode) {
            if (localStorage.getItem(this.storageKey) === null) {
                this.openPopupModal();
            } else {
                var stored = JSON.parse(localStorage.getItem(this.storageKey));
                var nextDate = new Date(stored.next_display_date);
                if (currentDate.getTime() > nextDate.getTime()) {
                    this.openPopupModal();
                }
            }
        } else {
            if (this.timer) this.displayPromoTimer();
        }

        this.closeBtns.forEach(function(btn) {
            btn.addEventListener('click', this.closeModal.bind(this));
        }.bind(this));
    }

    openPopupModal() {
        setTimeout(function() {
            this.modal.classList.add('popup-modal--active');
            this.overlay.classList.add('popup-overlay--active');
            document.body.classList.add('overflow-hidden');

            var closeBtn = this.modal.querySelector('.popup-modal__close');
            if (closeBtn) closeBtn.focus({ preventScroll: true });

            var nextDate = addDays(currentDate, parseInt(this.daysFrequency));
            localStorage.setItem(this.storageKey, JSON.stringify({
                next_display_date: nextDate,
                dismissed: false
            }));
            if (this.timer) this.displayPromoTimer();
        }.bind(this), parseInt(this.secondsDelay) * 1000 + 3000);
    }

    displayPromoTimer() {
        this.minutesSpan = this.querySelector('.popup-modal__timer__minutes');
        this.secondsSpan = this.querySelector('.popup-modal__timer__seconds');
        this.totalSeconds = parseFloat(this.timerDuration) * 60;
        this.updateTimer();
        this.promoInterval = setInterval(function() {
            this.totalSeconds -= 1;
            this.updateTimer();
            if (this.totalSeconds <= 0) {
                this.totalSeconds = parseFloat(this.timerDuration) * 60 - 45;
            }
        }.bind(this), 1000);
    }

    updateTimer() {
        var min = Math.floor(this.totalSeconds / 60);
        if (min.toString().length === 1) min = '0' + min;
        var sec = this.totalSeconds % 60;
        if (sec.toString().length === 1) sec = '0' + sec;
        this.minutesSpan.textContent = min;
        this.secondsSpan.textContent = sec;
    }

    closeModal() {
        if (this.promoInterval) {
            clearInterval(this.promoInterval);
            this.promoInterval = null;
        }
        this.modal.classList.remove('popup-modal--active');
        this.overlay.classList.remove('popup-overlay--active');
        document.body.classList.remove('overflow-hidden');
    }
}
customElements.define('promo-popup', PromoPopup);
initTrapFocus();
class SectionsGroup extends HTMLElement {
    constructor() {
        super(),
        this.sectionOneContainer = this.querySelector('.section-group__section-one-container'),
        this.sectionTwoContainer = this.querySelector('.section-group__section-two-container'),
        this.transferSections(),
        document.addEventListener('shopify:section:load', this.transferSections.bind(this));
    }
    transferSections() {
        this.sectionOne = document.querySelector(this.dataset.sectionOneId + ' .content-for-grouping'),
        this.sectionTwo = document.querySelector(this.dataset.sectionTwoId + ' .content-for-grouping');
        if (this.sectionOne && !this.sectionOneContainer['childNodes'].length)
            this.sectionOneContainer.appendChild(this.sectionOne);
        if (this.sectionTwo && !this.sectionTwoContainer.childNodes.length)
            this.sectionTwoContainer.appendChild(this.sectionTwo);
    }
}
customElements.define('section-group', SectionsGroup);
class ClickableDiscount extends HTMLElement {
    constructor() {
        super(),
        this.button = this.querySelector('.clickable-discount__btn'),
        this.button.addEventListener('click', this.handleClick.bind(this)),
        this.dataset.applied === 'true' ? this.handleClick() : this.reapplyDiscountIfApplicable();
    }
    handleClick() {
        this.dataset.loading = 'true',
        this.button['disabled'] = true,
        this['dataset'].error = 'false',
        fetch('/discount/' + this.dataset.code).then(response => {
            if (!response['ok'])
                throw new Error('Error');
            this['dataset'].applied = 'true',
            sessionStorage.setItem('discount-' + this.dataset['code'] + '-applied', 'true');
        })['catch'](error => {
            this.dataset.error = 'true',
            this.button.disabled = false;
        })['finally']( () => {
            this.dataset.loading = 'false';
        });
    }
    reapplyDiscountIfApplicable() {
        const code = this.dataset['code'];
        sessionStorage.getItem('discount-' + code + '-applied') && (this.dataset.applied = 'true',
        this['button']['disabled'] = true,
        setTimeout( () => {
            fetch('/discount/' + code)['catch'](error => {
                this.dataset.applied = 'false',
                this.button.disabled = false;
            });
        }, 3000));
    }
}
customElements.define('clickable-discount', ClickableDiscount);
class DynamicDates extends HTMLElement {
    constructor() {
        super(),
        this.dateFormat = this.dataset['dateFormat'],
        this.days = this.rearrangeDays(this['dataset']['dayLabels'].split(',')),
        this.months = this['dataset'].monthLabels.split(','),
        this['elementsToChange'] = this.querySelectorAll('[data-dynamic-date="true"]'),
        this.insertDates(),
        document.addEventListener('shopify:section:load', event => {
            this.insertDates();
        });
    }
    insertDates() {
        this.elementsToChange.forEach(el => {
            const text = el.dataset['text']
              , minDays = parseInt(el.dataset.minDays)
              , maxDays = parseInt(el['dataset'].maxDays)
              , startDate = addDays(currentDate, minDays);
            let startSuffix = 'th';
            const startDay = startDate.getDate();
            if (startDay === 1 || startDay === 21 || startDay === 31)
                startSuffix = 'st';
            else {
                if (startDay === 2 || startDay === 22)
                    startSuffix = 'nd';
                else {
                    if (startDay === 3 || startDay === 23)
                        startSuffix = 'rd';
                }
            }
            const endDate = addDays(currentDate, maxDays);
            let endSuffix = 'th';
            const endDay = endDate['getDate']();
            if (endDay === 1 || endDay === 21 || endDay === 31)
                endSuffix = 'st';
            else {
                if (endDay === 2 || endDay === 22)
                    endSuffix = 'nd';
                else {
                    if (endDay === 3 || endDay === 23)
                        endSuffix = 'rd';
                }
            }
            let startFormatted, endFormatted;
            if (this.dateFormat === 'day_dd_mm')
                startFormatted = this['days'][startDate.getDay()] + ', ' + startDate.getDate() + '. ' + this.months[startDate.getMonth()],
                endFormatted = this.days[endDate.getDay()] + ', ' + endDate.getDate() + '. ' + this['months'][endDate['getMonth']()];
            else {
                if (this['dateFormat'] === 'day_dd_mm_numeric') {
                    const dd1 = String(startDate.getDate()).length > 1 ? startDate.getDate() : '0' + startDate.getDate()
                      , mm1 = String(startDate.getMonth() + 1).length > 1 ? startDate.getMonth() + 1 : '0' + (startDate.getMonth() + 1);
                    startFormatted = this.days[startDate.getDay()] + ', ' + dd1 + '. ' + mm1 + '.';
                    const dd2 = String(endDate.getDate()).length > 1 ? endDate['getDate']() : '0' + endDate['getDate']()
                      , mm2 = String(endDate.getMonth() + 1).length > 1 ? endDate.getMonth() + 1 : '0' + (endDate.getMonth() + 1);
                    endFormatted = this['days'][endDate.getDay()] + ', ' + dd2 + '. ' + mm2 + '.';
                } else {
                    if (this.dateFormat === 'dd_mm_numeric') {
                        const dd1 = String(startDate['getDate']()).length > 1 ? startDate['getDate']() : '0' + startDate.getDate()
                          , mm1 = String(startDate['getMonth']() + 1).length > 1 ? startDate.getMonth() + 1 : '0' + (startDate['getMonth']() + 1);
                        startFormatted = dd1 + '. ' + mm1 + '.';
                        const dd2 = String(endDate['getDate']()).length > 1 ? endDate.getDate() : '0' + endDate.getDate()
                          , mm2 = String(endDate['getMonth']() + 1).length > 1 ? endDate.getMonth() + 1 : '0' + (endDate.getMonth() + 1);
                        endFormatted = dd2 + '. ' + mm2 + '.';
                    } else if (this.dateFormat === 'dd_mm')
                        startFormatted = startDate.getDate() + '. ' + this['months'][startDate['getMonth']()],
                        endFormatted = endDate.getDate() + '. ' + this['months'][endDate.getMonth()];
                    else if (this.dateFormat === 'dd_mm_no_dot')
                        startFormatted = startDate.getDate() + ' ' + this['months'][startDate.getMonth()],
                        endFormatted = endDate.getDate() + ' ' + this['months'][endDate.getMonth()];
                    else
                        startFormatted = this.days[startDate['getDay']()] + ', ' + this.months[startDate.getMonth()] + ' ' + startDate.getDate() + startSuffix,
                        endFormatted = this['days'][endDate.getDay()] + ', ' + this['months'][endDate.getMonth()] + ' ' + endDate.getDate() + endSuffix;
                }
            }
            const replaced1 = text.replace('[start_date]', startFormatted)
              , replaced2 = replaced1['replace']('[end_date]', endFormatted);
            el.innerHTML = replaced2;
        });
    }
    rearrangeDays(daysArray) {
        return daysArray['unshift'](daysArray[6]),
        daysArray.length = 7,
        daysArray;
    }
}
customElements.define('dynamic-dates', DynamicDates);
class StickyAtc extends HTMLElement {
    constructor() {
        super(),
        this.isAfterScroll = this.dataset.afterScroll === 'true',
        this.isScrollBtn = this['dataset'].scrollBtn === 'true',
        this.mainAtcBtn = document.querySelector('#ProductSubmitButton-' + this['dataset'].section),
        this.floatingBtns = document.querySelectorAll('.floating-btn'),
        this.footerSpacing();
        this['isAfterScroll'] ? this.mainAtcBtn && (this.checkATCScroll(),
        this._scrollRaf = null, document.addEventListener('scroll', () => { this._scrollRaf || (this._scrollRaf = requestAnimationFrame(() => { this.checkATCScroll(), this._scrollRaf = null; })); })) : this.floatingBtns.forEach(btn => {
            btn.style.setProperty('--sticky-atc-offset', this.offsetHeight + 'px');
        });
        if (this.isScrollBtn) {
            this.scrollBtn = this.querySelector('.sticky-atc__scroll-btn'),
            this.scrollDestination = document.querySelector('' + this.dataset['scrollDestination'].replace('id', this.dataset['section']));
            if (this.scrollBtn && this.scrollDestination)
                this.scrollBtn.addEventListener('click', this.handleScrollBtn.bind(this));
        }
    }
    checkATCScroll() {
        if (window.packVariantScrolling === true) return;
        window.scrollY > this.mainAtcBtn.offsetTop + this['mainAtcBtn']['offsetHeight'] ? (this.style['transform'] = 'none',
        this.scrolledPast = true) : (this.style.transform = '',
        this['scrolledPast'] = false),
        this.floatingBtns.forEach(btn => {
            this.scrolledPast ? btn.style.setProperty('--sticky-atc-offset', this.offsetHeight + 'px') : btn.style.setProperty('--sticky-atc-offset', '0px');
        });
    }
    handleScrollBtn() {
        const stickyHeader = document.querySelector('sticky-header')
          , headerHeight = stickyHeader ? stickyHeader.clientHeight : 0;
        window.scrollTo({
            'top': this.scrollDestination.offsetTop - headerHeight - 15,
            'behavior': 'smooth'
        });
    }
    footerSpacing() {
        let spacer = document.querySelector('.sticky-atc-footer-spacer');
        if (spacer)
            return;
        spacer = document.createElement('div'),
        spacer.className = 'sticky-atc-footer-spacer',
        spacer.style.height = this['clientHeight'] - 1 + 'px',
        spacer.style['display'] = 'block';
        const footer = document.querySelector('.footer');
        if (footer)
            spacer.style.background = window.getComputedStyle(footer)['background'];
        document.body.appendChild(spacer);
    }
}
customElements.define('sticky-atc', StickyAtc);
class BundleDeals extends HTMLElement {
    constructor() {
        super(),
        this.productContainers = this.querySelectorAll('.bundle-deals__product-js'),
        this['mediaItemContainers'] = this.querySelectorAll('.bundle-deals__media-item-container-js'),
        this.mediaItemImgs = this.querySelectorAll('.bundle-deals__media-item-img-js'),
        this.checkboxes = this.querySelectorAll('.bundle-deals__checkbox-js'),
        this['variantPickers'] = this.querySelectorAll('.bundle-deals__variant-selects-js'),
        this['skipNonExistent'] = this.dataset.skipNonExistent === 'true',
        this.skipUnavailable = this.dataset.skipUnavailable === 'true',
        this['prices'] = this['querySelectorAll']('.bundle-deals__price-js'),
        this['comparePrices'] = this['querySelectorAll']('.bundle-deals__compare-price-js'),
        this.totalPrice = this.querySelector('.bundle-deals__total-price-js'),
        this['totalComparePrice'] = this.querySelector('.bundle-deals__total-compare-price-js'),
        this.updatePrices = this['dataset'].updatePrices === 'true',
        this.percentageLeft = parseFloat(this.dataset['percentageLeft']),
        this.fixedDiscount = parseFloat(this['dataset'].fixedDiscount),
        this.currencySymbol = this.dataset.currencySymbol,
        this['selectedVariants'] = {
            'id_1': null,
            'id_2': null,
            'id_3': null,
            'id_4': null,
            'id_5': null
        },
        this['formVariants'] = [],
        this.initIds(),
        this.checkboxes.forEach(checkbox => {
            checkbox.addEventListener('change', this.handleCheckboxChange.bind(this));
        }),
        this['variantPickers'].forEach(picker => {
            picker.addEventListener('change', this.handleSelectChange.bind(this));
        });
    }
    initIds() {
        this.checkboxes.forEach(checkbox => {
            this['selectedVariants'][checkbox.dataset.idIndex] = {
                'id': checkbox.dataset['id'],
                'price': checkbox.dataset.price,
                'comparePrice': checkbox['dataset'].comparePrice,
                'checked': true
            };
        }),
        this.updateFormIds();
    }
    ['handleCheckboxChange'](event) {
        const target = event.currentTarget
          , isChecked = target.checked
          , idx = parseInt(target.dataset.index);
        this.selectedVariants[target.dataset.idIndex].checked = isChecked;
        const container = this['productContainers'][idx]
          , selects = container.querySelectorAll('.select__select');
        isChecked ? (this['mediaItemContainers'][idx].classList.remove('bundle-deals__media-item--disabled'),
        container.classList.remove('bundle-deals__product--deselected'),
        selects['forEach'](sel => {
            sel.removeAttribute('disabled');
        })) : (this.mediaItemContainers[idx].classList.add('bundle-deals__media-item--disabled'),
        container.classList['add']('bundle-deals__product--deselected'),
        selects['forEach'](sel => {
            sel.setAttribute('disabled', '');
        }));
        this['updateFormIds']();
        if (this.updatePrices)
            this.updateTotalPrices();
    }
    handleSelectChange(event) {
        const picker = event.currentTarget
          , idx = parseInt(picker.dataset.index)
          , selectedOptions = Array.from(picker.querySelectorAll('.select__select'), sel => sel.value)
          , variantJSON = JSON.parse(picker.querySelector('[type="application/json"]').textContent)
          , variantData = variantJSON.filter(v => picker['querySelector'](':checked').value === v.option1)
          , selectElements = [...picker['querySelectorAll']('.select--small')];
        updateVariantStatuses(variantData, selectElements);
        const matchedVariant = variantJSON.find(variant => {
            return !variant.options.map( (opt, i) => {
                return selectedOptions[i] === opt;
            }).includes(false);
        });
        if (!matchedVariant) {
            if (this.skipNonExistent)
                findAvailableVariant(picker, selectedOptions, false, true, this.skipUnavailable);
            return;
        }
        if (this.skipUnavailable && !matchedVariant.available) {
            if (findAvailableVariant(picker, selectedOptions, false, true, true))
                return;
        }
        let {price, compare_at_price, featured_image} = matchedVariant;
        price = parseInt(price);
        let comparePrice = compare_at_price ? parseInt(compare_at_price) : price;
        const pctLeft = picker.dataset['percentageLeft'] ?? 1
          , fixedDisc = picker.dataset.fixedDiscount ?? 0;
        price = price * pctLeft - fixedDisc;
        if (featured_image)
            featured_image = featured_image.src;
        const variantId = matchedVariant['id'];
        this.selectedVariants[picker.dataset.idIndex]['id'] = variantId,
        this.selectedVariants[picker['dataset'].idIndex].price = price,
        this.selectedVariants[picker.dataset.idIndex]['comparePrice'] = comparePrice,
        this.updateFormIds(),
        this['updatePrices'] && (this.prices[idx]['innerHTML'] = this.currencySymbol + (price / 100).toFixed(2),
        comparePrice > price ? this['comparePrices'][idx].innerHTML = this['currencySymbol'] + (comparePrice / 100)['toFixed'](2) : this.comparePrices[idx].innerHTML = '',
        this.updateTotalPrices()),
        featured_image && featured_image.length > 0 && this.mediaItemImgs[idx] && (this.mediaItemImgs[idx]['src'] = featured_image);
    }
    updateFormIds() {
        const formVariants = []
          , variants = this.selectedVariants;
        for (const key in variants) {
            const variant = variants[key];
            if (variant != null && variant.checked) {
                const existingIdx = formVariants.findIndex(fv => fv['id'] === variant['id']);
                existingIdx < 0 ? formVariants.unshift({
                    'id': variant['id'],
                    'quantity': 1
                }) : formVariants[existingIdx].quantity += 1;
            }
        }
        this.formVariants = formVariants;
    }
    updateTotalPrices() {
        const priceArr = []
          , comparePriceArr = []
          , variants = this.selectedVariants;
        for (const key in variants) {
            const variant = variants[key];
            variant != null && variant.checked && (priceArr.push(parseInt(variant.price)),
            comparePriceArr.push(parseInt(variant.comparePrice)));
        }
        const totalPrice = priceArr.reduce( (sum, val) => sum + val, 0)
          , discountedTotal = totalPrice * this.percentageLeft - this['fixedDiscount']
          , totalCompare = comparePriceArr['reduce']( (sum, val) => sum + val, 0);
        this.totalPrice.innerHTML = this['currencySymbol'] + (discountedTotal / 100).toFixed(2),
        totalCompare > discountedTotal ? this.totalComparePrice['innerHTML'] = this['currencySymbol'] + (totalCompare / 100).toFixed(2) : this.totalComparePrice['innerHTML'] = '';
    }
}
customElements['define']('bundle-deals', BundleDeals);
class QuantityBreaks extends HTMLElement {
    constructor() {
        super(),
        this.quantityGifts = document.getElementById('quantity-gifts-' + this.dataset.section),
        this.inputs = this.querySelectorAll('input[name="quantity"]'),
        this.labels = this.querySelectorAll('.quantity-break'),
        this.jsonData = this.querySelector('[type="application/json"]'),
        this.hasVariants = this.jsonData.dataset.hasVariants === 'true',
        this.selectedVariants = {
            'input_1': [],
            'input_2': [],
            'input_3': [],
            'input_4': [],
            'input_5': [],
            'input_6': []
        },
        this['updateUnavailable'] = this.dataset.updateUnavailable === 'true',
        this.skipNonExistent = this.dataset.skipNonExistent === 'true',
        this.skipUnavailable = this.dataset['skipUnavailable'] === 'true',
        this['formVariants'] = [],
        this.selectedQuantity = 1;
        if (this.querySelector('input[checked]'))
            this.selectedQuantity = parseInt(this.querySelector('input[checked]')['value']);
        this['variantSelects'] = this['querySelectorAll']('.quantity-break__selector-item'),
        this.updatePrices = this.dataset.updatePrices === 'true',
        this['moneyFormat'] = this['dataset'].moneyFormat;
        if (this.hasVariants)
            this['initVariants']();
        this.inputs.forEach(input => {
            input.addEventListener('change', this.handleChange.bind(this));
        }),
        this['variantSelects'].forEach(sel => {
            sel.addEventListener('change', this.handleSelectChange.bind(this));
        });
    }
    handleSelectChange(event) {
        const target = event.currentTarget
          , selectedOptions = Array.from(target.querySelectorAll('select'), sel => sel['value'])
          , variantPool = this.getVariantData();
        if (this['updateUnavailable']) {
            const variantData = variantPool.filter(v => target.querySelector(':checked').value === v.option1)
              , selectElements = [...target['querySelectorAll']('.select--small')];
            updateVariantStatuses(variantData, selectElements);
        }
        const matchedVariant = variantPool['find'](variant => {
            return !variant['options'].map( (opt, i) => {
                return selectedOptions[i] === opt;
            })['includes'](false);
        });
        if (!matchedVariant) {
            if (this.skipNonExistent)
                findAvailableVariant(target, selectedOptions, false, true, this.skipUnavailable);
            return;
        }
        if (this['skipUnavailable'] && !matchedVariant.available) {
            if (findAvailableVariant(target, selectedOptions, false, true, true))
                return;
        }
        target['dataset'].selectedId = matchedVariant['id'];
        const selectIndex = target['dataset'].selectIndex
          , breakContainer = target.closest('.quantity-break')
          , inputKey = breakContainer['dataset'].input;
        this.selectedVariants[inputKey][selectIndex] = matchedVariant['id'],
        this['formVariants'] = this.selectedVariants[inputKey],
        this.updateMedia(matchedVariant);
        if (!this.updatePrices)
            return;
        var totalPrice = 0
          , totalCompare = 0;
        const qty = parseFloat(breakContainer['dataset'].quantity)
          , pctLeft = parseFloat(breakContainer['dataset']['percentageLeft'])
          , fixedDisc = parseFloat(breakContainer.dataset['fixedDiscount']);
        const allVariants = this.getVariantData();
        for (let i = 0; i < qty; i++) {
            const varId = parseInt(this['selectedVariants'][inputKey][i])
              , variant = allVariants.find(v => parseInt(v['id']) === varId);
            if (!variant)
                return;
            totalPrice += variant.price,
            variant.compare_at_price && variant['compare_at_price'] > variant.price ? totalCompare += variant.compare_at_price : totalCompare += variant['price'];
        }
        totalPrice = totalPrice * pctLeft - fixedDisc;
        const amountSaved = totalCompare - totalPrice
          , amountSavedRounded = Math.round(amountSaved / 100) * 100
          , priceEach = totalPrice / qty
          , comparePriceEach = totalCompare / qty
          , priceFormatted = formatMoney(totalPrice, this.moneyFormat, true)
          , comparePriceFormatted = formatMoney(totalCompare, this['moneyFormat'], true)
          , savedFormatted = formatMoney(amountSaved, this.moneyFormat, true)
          , savedRoundedFormatted = formatMoney(amountSavedRounded, this['moneyFormat'], true)
          , priceEachFormatted = formatMoney(priceEach, this['moneyFormat'], true)
          , comparePriceEachFormatted = formatMoney(comparePriceEach, this.moneyFormat, true);
        breakContainer['querySelectorAll']('.variant-price-update').forEach(el => {
            let text = el.dataset.text;
            text = text['replace']('[quantity]', qty),
            text = text.replace('[price]', priceFormatted),
            text = text['replace']('[compare_price]', comparePriceFormatted),
            text = text.replace('[amount_saved]', savedFormatted),
            text = text.replace('[amount_saved_rounded]', savedRoundedFormatted),
            text = text.replace('[price_each]', priceEachFormatted),
            text = text.replace('[compare_price_each]', comparePriceEachFormatted),
            el.innerHTML = text;
        });
        const compareEl = breakContainer.querySelector('.quantity-break__compare-price');
        compareEl && (totalCompare > totalPrice ? compareEl.classList.remove('hidden') : compareEl['classList'].add('hidden'));
    }
    getVariantData() {
        return this.variantData = this.variantData || JSON['parse'](this.jsonData.textContent),
        this.variantData;
    }
    ['initVariants']() {
        if (!this.hasVariants)
            return;
        this.labels.forEach(label => {
            if (label['querySelector']('.quantity-break__variants')) {
                let ids = [];
                label['querySelectorAll']('.quantity-break__selector-item').forEach(sel => {
                    ids['push'](sel.dataset.selectedId);
                }),
                this['selectedVariants'][label.dataset.input] = ids;
            }
        }),
        this.formVariants = [];
    }
    updateMedia(variant) {
        if (!variant)
            return;
        if (!variant.featured_media)
            return;
        const galleries = document['querySelectorAll']('[id^="MediaGallery-' + this.dataset['section'] + '"]');
        galleries.forEach(gallery => gallery.setActiveMedia(this.dataset['section'] + '-' + variant.featured_media['id'], true));
    }
    handleChange(event) {
        const value = parseInt(event.target.value);
        this.selectedQuantity = value;
        if (this.hasVariants)
            this['formVariants'] = this.selectedVariants[event.target['dataset'].input];
        if (this['quantityGifts'])
            this.quantityGifts['unlockGifts'](value);
    }
}
customElements.define('quantity-breaks', QuantityBreaks);
function updateVariantStatuses(variantData, selectElements) {
    selectElements.forEach( (selectEl, index) => {
        if (index === 0)
            return;
        const options = [...selectEl.querySelectorAll('option')]
          , prevValue = selectElements[index - 1].querySelector(':checked').value
          , optionKey = 'option' + index
          , nextOptionKey = 'option' + (index + 1);
        const availableVariants = [];
        const allMatchingVariants = [];
        for (let i = 0; i < variantData.length; i++) {
            const v = variantData[i];
            if (v[optionKey] === prevValue) {
                const next = v[nextOptionKey];
                allMatchingVariants.push(next);
                if (v.available) availableVariants.push(next);
            }
        }
        options.forEach(option => {
            const val = option.getAttribute('value');
            option.classList.remove('unavailable', 'non-existent');
            if (allMatchingVariants.includes(val)) {
                if (availableVariants.includes(val)) {
                    option.innerText = val;
                } else {
                    option.innerText = window.variantStrings.unavailable_with_option.replace('[value]', val);
                    option.classList.add('unavailable');
                }
            } else {
                option.innerText = window.variantStrings.unavailable_with_option.replace('[value]', val);
                option.classList.add('non-existent');
            }
        });
    });
}
function findAvailableVariant(container, selectedOptions, isMainProduct=true, skipNonExistent=false, skipUnavailable=false) {
    for (let i = selectedOptions.length - 1; i >= 0; i--) {
        const inputWrapper = isMainProduct ? container.querySelector('.product-form__input:nth-child(' + (i + 1) + ')') : container.querySelectorAll('.select--small')[i]
          , inputType = isMainProduct ? inputWrapper.querySelector('.product-form__input__type').dataset.type : 'dropdown'
          , optionElements = inputType === 'dropdown' ? inputWrapper.querySelectorAll('option') : inputWrapper.querySelectorAll('input[type="radio"]');
        let currentIndex = Array.from(optionElements).findIndex(el => el.value === selectedOptions[i])
          , found = false;
        while (currentIndex < optionElements['length'] - 1) {
            currentIndex++;
            const option = optionElements[currentIndex];
            if ((!skipNonExistent || !option.classList.contains('non-existent')) && (!skipUnavailable || !option['classList'].contains('unavailable'))) {
                selectedOptions[i] = option['value'],
                found = true;
                break;
            }
        }
        if (!found) {
            currentIndex = Array.from(optionElements).findIndex(el => el.value === selectedOptions[i]);
            while (currentIndex > 0) {
                currentIndex--;
                const option = optionElements[currentIndex];
                if ((!skipNonExistent || !option.classList.contains('non-existent')) && (!skipUnavailable || !option.classList.contains('unavailable'))) {
                    selectedOptions[i] = option.value,
                    found = true;
                    break;
                }
            }
        }
        if (found)
            return inputType === 'dropdown' ? inputWrapper.querySelector('.select__select').value = selectedOptions[i] : inputWrapper.querySelector('input[type="radio"][value="' + selectedOptions[i] + '"]')['checked'] = true,
            container.dispatchEvent(new Event('change')),
            true;
    }
    return false;
}
class QuantityGifts extends HTMLElement {
    constructor() {
        super(),
        this['gifts'] = this.querySelectorAll('.quantity-gift'),
        this.quantityBreaks = document.getElementById('quantity-breaks-' + this.dataset.section),
        this.quantitySelector = document.getElementById('Quantity-Form--' + this.dataset.section),
        this.unlockedItems = [],
        this.initUnlock();
    }
    initUnlock() {
        let qty = 1;
        if (this.quantityBreaks)
            qty = parseInt(this['quantityBreaks'].selectedQuantity);
        else {
            if (this.quantitySelector) {
                const input = this.quantitySelector.querySelector('input[name="quantity"]');
                qty = parseInt(input.value);
            }
        }
        this['unlockGifts'](qty);
    }
    unlockGifts(qty) {
        this.unlockedItems = [],
        this.gifts.forEach(gift => {
            if (parseInt(gift.dataset.quantity) <= qty) {
                gift.classList.add('quantity-gift--unlocked'),
                gift['dataset'].unlocked = 'true';
                if (gift.dataset.product)
                    this.unlockedItems['unshift'](gift.dataset['product']);
            } else
                gift.classList.remove('quantity-gift--unlocked'),
                gift['dataset'].unlocked = 'false';
        });
    }
}
customElements.define('quantity-gifts', QuantityGifts);

class ProductInfoUpsell extends HTMLElement {
    constructor() {
        super(),
        this.image = this.querySelector('.upsell__image__img'),
        this['toggleBtn'] = this.querySelector('.upsell-toggle-btn'),
        this.variantSelects = this.querySelector('.upsell__variant-picker'),
        this.variantSelectElements = this.querySelectorAll('.select__select'),
        this.jsonData = this.querySelector('[type="application/json"]'),
        this.productForm = this.querySelector('product-form');
        if (this['productForm'])
            this.idInput = this.productForm.querySelector('[name="id"]');
        this['skipNonExistent'] = this.dataset.skipNonExistent === 'true',
        this.skipUnavailable = this.dataset.skipUnavailable === 'true',
        this['updatePrices'] = this.dataset['updatePrices'] === 'true';
        if (this.updatePrices) {
            this.price = parseInt(this['dataset'].price),
            this['comparePrice'] = parseInt(this.dataset.comparePrice),
            this['priceSpan'] = this['querySelector']('.upsell__price .regular-price'),
            this.comparePriceSpan = this.querySelector('.upsell__price .compare-price'),
            this.percentageLeft = parseFloat(this.dataset.percentageLeft),
            this.fixedDiscount = parseFloat(this.dataset.fixedDiscount),
            this.moneyFormat = this.dataset.moneyFormat,
            this.isMainOfferItem = this.dataset.mainOfferItem === 'true';
            if (this.isMainOfferItem)
                this['mainOfferContainer'] = document['querySelector']('#MainBundleOffer-' + this.dataset.section);
        }
        if (this.toggleBtn)
            this['toggleBtn'].addEventListener('click', this.handleToggle.bind(this));
        if (this.variantSelects)
            this.variantSelects.addEventListener('change', this.handleSelectChange.bind(this));
    }
    handleToggle(event) {
        if (event['target'].nodeName.toLowerCase() === 'select' || event['target'].nodeName.toLowerCase() === 'option')
            return;
        this['dataset'].selected === 'true' ? this.dataset.selected = 'false' : this.dataset.selected = 'true';
    }
    handleSelectChange(event) {
        const target = event.currentTarget
          , selectedOptions = Array['from'](target.querySelectorAll('.select__select'), sel => sel.value)
          , matchedVariant = this.getVariantData().find(variant => {
            return !variant.options['map']( (opt, i) => {
                return selectedOptions[i] === opt;
            }).includes(false);
        })
          , filteredVariants = this['getVariantData']().filter(v => target.querySelector(':checked').value === v.option1)
          , selectElements = [...target.querySelectorAll('.select__select')];
        updateVariantStatuses(filteredVariants, selectElements);
        if (!matchedVariant) {
            if (this.skipNonExistent)
                findAvailableVariant(target, selectedOptions, false, true, this.skipUnavailable);
            return;
        }
        if (this.skipUnavailable && !matchedVariant['available']) {
            if (findAvailableVariant(target, selectedOptions, false, true, true))
                return;
        }
        this.updatePrices && (this.price = matchedVariant['price'] * this['percentageLeft'] - this.fixedDiscount,
        this.comparePrice = matchedVariant['price'],
        matchedVariant.compare_at_price && matchedVariant.compare_at_price > matchedVariant.price && (this.comparePrice = matchedVariant.compare_at_price),
        displayPrices(this.price, this.comparePrice, this.priceSpan, this['comparePriceSpan'], this.moneyFormat));
        if (this.image && matchedVariant.featured_image)
            this.image.src = matchedVariant.featured_image.src;
        this.updateId(matchedVariant['id']);
        if (this.isMainOfferItem && this.mainOfferContainer.updateTotalPrices)
            this.mainOfferContainer.updateTotalPrices();
    }
    ['updateId'](id) {
        this.dataset['id'] = id;
        if (this['idInput'])
            this.idInput.value = id;
    }
    getVariantData() {
        return this.variantData = this.variantData || JSON.parse(this.jsonData.textContent),
        this['variantData'];
    }
}
customElements['define']('product-info-upsell', ProductInfoUpsell);
class CartDrawerUpsell extends ProductInfoUpsell {
    constructor() {
        super(),
        this.cartDrawer = document.querySelector('cart-drawer'),
        this['cartItems'] = this.cartDrawer.querySelector('cart-drawer-items'),
        this['classicAddButton'] = this['querySelector']('.upsell__add-btn');
    }
    handleToggle(event) {
        if (event.target.nodeName['toLowerCase']() === 'select' || event['target'].nodeName['toLowerCase']() === 'option')
            return;
        this['dataset'].selected === 'true' ? (this.dataset.selected = 'false',
        this.removeFromCart()) : (this.dataset['selected'] = 'true',
        this['addToCart']());
    }
    ['addRemoveFromCart']() {
        this.dataset['selected'] === 'true' && !this.cartDrawer['classList']['contains']('is-empty') ? this['addToCart']() : this.removeFromCart();
    }
    ['addToCart']() {
        const existingItem = this.cartDrawer.querySelector('.cart-item--product-' + this.dataset['handle']);
        if (existingItem)
            return;
        if (this.toggleBtn)
            this['toggleBtn']['setAttribute']('disabled', '');
        this.variantSelectElements['forEach'](sel => {
            sel.setAttribute('disabled', '');
        }),
        this.productForm.handleSubmit();
    }
    ['removeFromCart']() {
        const cartItem = this.cartDrawer.querySelector('.cart-item--product-' + this.dataset.handle);
        if (!cartItem || !this.cartItems)
            return;
        if (this.toggleBtn)
            this.toggleBtn.setAttribute('disabled', '');
        this.variantSelectElements.forEach(sel => {
            sel.setAttribute('disabled', '');
        }),
        this['cartItems'].updateQuantity(cartItem.dataset.index, 0);
    }
    updateId(id) {
        this.dataset['id'] = id,
        this.idInput['value'] = id;
        if (this.classicAddButton)
            return;
        if (this.dataset.selected === 'true') {
            this['selectTimeout'] && clearTimeout(this['selectTimeout']);
            this.removeFromCart();
            const onCartUpdate = (event) => {
                if (event.detail.handle === 'handle') {
                    this.addToCart(),
                    document.removeEventListener('cartQuantityUpdated', onCartUpdate);
                }
            };
            document['addEventListener']('cartQuantityUpdated', onCartUpdate);
        }
    }
    getUpdateRequired() {
        const existingItem = this.cartDrawer['querySelector']('.cart-item--product-' + this['dataset']['handle']);
        let needsUpdate = false;
        if (existingItem && this.dataset.selected === 'false')
            needsUpdate = true;
        else
            !existingItem && this.dataset.selected === 'true' && (needsUpdate = true);
        return needsUpdate;
    }
}
customElements.define('cart-drawer-upsell', CartDrawerUpsell);
function displayPrices(price, comparePrice, priceSpan, comparePriceSpan, moneyFormat) {
    if (!moneyFormat)
        return;
    if (price && priceSpan) {
        var formattedPrice = formatMoney(price, moneyFormat);
        priceSpan['innerHTML'] = formattedPrice;
    }
    if (comparePrice && comparePriceSpan) {
        var formattedCompare = formatMoney(comparePrice, moneyFormat);
        comparePriceSpan.innerHTML = formattedCompare,
        comparePrice > price ? comparePriceSpan.classList.remove('hidden') : comparePriceSpan.classList.add('hidden');
    }
}
function initTrapFocus() {
    const footer = document.querySelector('footer');
    if (footer && footer.dataset.type === null)
        return false;
    return true;
}
function formatMoney(cents, format, skipZeroDecimals=false) {
    typeof cents == 'string' && (cents = cents.replace('.', ''));
    var formatString = ''
      , placeholderRegex = /\{\{\s*(\w+)\s*\}\}/
      , moneyFormat = format;
    function defaultOption(opt, defaultVal) {
        return typeof opt == 'undefined' ? defaultVal : opt;
    }
    function formatWithDelimiters(amount, precision, thousands, decimal) {
        precision = defaultOption(precision, 2),
        thousands = defaultOption(thousands, ','),
        decimal = defaultOption(decimal, '.');
        if (isNaN(amount) || amount == null)
            return 0;
        amount = (amount / 100).toFixed(precision);
        var parts = amount.split('.')
          , dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands)
          , cents = parts[1] ? decimal + parts[1] : '';
        return skipZeroDecimals && cents === decimal + '00' && (cents = ''),
        dollars + cents;
    }
    switch (moneyFormat.match(placeholderRegex)[1]) {
    case 'amount':
        formatString = formatWithDelimiters(cents, 2);
        break;
    case 'amount_no_decimals':
        formatString = formatWithDelimiters(cents, 0);
        break;
    case 'amount_with_comma_separator':
        formatString = formatWithDelimiters(cents, 2, '.', ',');
        break;
    case 'amount_no_decimals_with_comma_separator':
        formatString = formatWithDelimiters(cents, 0, '.', ',');
        break;
    }
    return moneyFormat['replace'](placeholderRegex, formatString);
}
class CartDrawerGift extends CartDrawerUpsell {
    constructor() {
        super();
    }
}
customElements.define('cart-drawer-gift', CartDrawerGift);
function initToggleUpsells() {
    const cartDrawer = document['querySelector']('cart-drawer');
    cartDrawer && cartDrawer['querySelectorAll']('cart-drawer-upsell[data-toggle="true"], cart-drawer-gift').forEach(upsell => {
        if (upsell.addRemoveFromCart)
            upsell.addRemoveFromCart();
    });
}
initToggleUpsells();
class MainBundleOffer extends HTMLElement {
    constructor() {
        super(),
        this['offerItems'] = this['querySelectorAll']('.main-offer-item'),
        this.updatePrices = this.dataset.updatePrices === 'true',
        this.updatePrices && (this.priceSpan = this['querySelector']('.bundle-deals__total-price-js'),
        this['comparePriceSpan'] = this.querySelector('.bundle-deals__total-compare-price-js'),
        this.percentageLeft = parseFloat(this.dataset['percentageLeft']),
        this['fixedDiscount'] = parseFloat(this['dataset'].fixedDiscount),
        this.moneyFormat = this.dataset.moneyFormat);
    }
    updateTotalPrices() {
        if (!this.updatePrices)
            return;
        var totalPrice = 0
          , totalCompare = 0;
        for (let i = 0; i < this['offerItems']['length']; i++) {
            totalPrice += parseInt(this.offerItems[i]['price']),
            totalCompare += parseInt(this.offerItems[i].comparePrice);
        }
        totalPrice = totalPrice * this.percentageLeft - this.fixedDiscount,
        displayPrices(totalPrice, totalCompare, this.priceSpan, this['comparePriceSpan'], this.moneyFormat);
    }
}
customElements.define('main-bundle-offer', MainBundleOffer);
class CustomProductField extends HTMLElement {
    constructor() {
        super();
    }
    ['connectedCallback']() {
        this.fieldName = this.dataset['name'],
        this['input'] = this.querySelector('[type="text"], [type="number"], textarea'),
        this['inputRadios'] = this.querySelectorAll('[type="radio"]'),
        this['select'] = this.querySelector('.select__select'),
        this.productForm = document.getElementById('product-form-' + this.dataset.section),
        this.prevValue = this['dataset'].defaultValue,
        this.isRequired = this.dataset.required === 'true',
        this.isText = true,
        this.notMain = this.dataset.notMain === 'true';
        if (this.dataset.type === 'select' || this.dataset.type === 'pills')
            this.isText = false;
        this.createInputs();
        this.isRequired && this.isText && (this.isValid = true,
        this.atcButtons = this['notMain'] ? document.querySelectorAll('.featured-product-atc-' + this.dataset.section) : document.querySelectorAll('.main-product-atc'),
        this.mainAtcButton = this.productForm.querySelector('#ProductSubmitButton-' + this.dataset.section),
        this.mainAtcBtnLabel = this['mainAtcButton'].querySelector('.main-atc__label'),
        this['mainAtcBtnError'] = this['mainAtcButton']['querySelector']('.main-atc__error'),
        this.atcErrorMsg = this['dataset'].atcErrorMsg,
        this.mainAtcButton.dataset.requiredFields = parseInt(this.mainAtcButton.dataset.requiredFields) + 1,
        this.mainAtcBtnError.innerHTML = this.atcErrorMsg,
        this.applyStickyAtcError = this.dataset['applyStickyAtcError'] === 'true',
        this.stickyAtcButton = document.querySelector('#sticky-atc-' + this.dataset.section),
        this.applyStickyAtcError && this.stickyAtcButton && (this.stickyAtcBtnLabel = this.stickyAtcButton['querySelector']('.sticky-atc__label'),
        this.stickyAtcBtnError = this.stickyAtcButton.querySelector('.sticky-atc__error'),
        this.stickyAtcBtnError['innerHTML'] = this['atcErrorMsg']),
        this.validateValue(this.prevValue, null));
        if (this['input'])
            this['input']['addEventListener']('input', this.handleChange['bind'](this));
        this.inputRadios.forEach(radio => {
            radio.addEventListener('input', this.handleChange.bind(this));
        });
        if (this['select'])
            this['select'].addEventListener('change', this['handleChange'].bind(this));
    }
    ['handleChange'](event) {
        const value = event['target'].value.trim();
        if (event.target.checkValidity())
            this.prevValue = value;
        else {
            event['target']['value'] = this['prevValue'];
            return;
        }
        this.dataset.value = value,
        this.productFormInput.value = value;
        if (this['isRequired'] && this['isText'])
            this['validateValue'](value, event['target']);
    }
    validateValue(value, inputEl) {
        const isValid = value.length > 0 ? true : false;
        if (isValid === this['isValid'])
            return;
        this['isValid'] = isValid;
        inputEl && (this.isValid ? (inputEl['classList']['remove']('input--error'),
        this.mainAtcButton.dataset['validFields'] = parseInt(this.mainAtcButton['dataset'].validFields) + 1) : (inputEl['classList'].add('input--error'),
        this.mainAtcButton['dataset'].validFields = parseInt(this.mainAtcButton.dataset.validFields) - 1));
        const allValid = this.mainAtcButton.dataset['validFields'] === this.mainAtcButton['dataset']['requiredFields']
          , isUnavailable = this.mainAtcButton.dataset.unavailable === 'true';
        this['atcButtons'].forEach(btn => {
            allValid && !isUnavailable ? btn.removeAttribute('disabled') : btn.setAttribute('disabled', '');
        });
        if (this.atcErrorMsg.length === 0)
            return;
        allValid ? (this.mainAtcBtnLabel.style.display = '',
        this.mainAtcBtnError.style.display = 'none',
        this['applyStickyAtcError'] && this.stickyAtcButton && (this.stickyAtcBtnLabel['style'].display = '',
        this['stickyAtcBtnError'].style.display = 'none')) : (this.mainAtcBtnLabel['style'].display = 'none',
        this.mainAtcBtnError.style.display = '',
        this.applyStickyAtcError && this['stickyAtcButton'] && (this.stickyAtcBtnLabel.style.display = 'none',
        this.stickyAtcBtnError['style']['display'] = ''));
    }
    createInputs() {
        this.productFormInput = document.createElement('input'),
        this.productFormInput.setAttribute('type', 'hidden'),
        this.productFormInput.setAttribute('name', 'properties[' + this.fieldName + ']'),
        this.productFormInput.value = this.dataset.defaultValue,
        this.productForm['appendChild'](this.productFormInput);
    }
}
customElements.define('custom-product-field', CustomProductField);
function playMedia() {
}

class VariantSelects extends HTMLElement {
    constructor() {
        super();
        this.secondarySelectSelector = 'StickyAtcVariantPicker-';
        this.secondarySelect = document.getElementById('' + this.secondarySelectSelector + this.dataset.section);
        this.isSecondary = false;
        this.QuantityBreaks = document.getElementById('quantity-breaks-' + this.dataset.section);
        this.hasQuantityBreaksPicker = this.dataset.hasQuantityBreaksPicker === 'true';
        this.prependMedia = this.dataset.disablePrepend != 'true';
        this.filtering = this.dataset.hasFiltering === 'true';
        this.skipNonExistent = this.dataset.skipNonExistent === 'true';
        this.skipUnavailable = this.dataset.skipUnavailable === 'true';
        this.hasQuantityBreaksPicker && (
            this.quantityBreaksPickerStyle = this.dataset.quantityBreaksPickerStyle,
            this.quantityBreaksPickerDisplayedImages = this.dataset.quantityBreaksPickerDisplayedImages
        );
        this.addEventListener('change', this.onVariantChange);
    }

    onVariantChange() {
        this.updateOptions();
        this.updateMasterId();
        this.toggleAddButton(true, '', false);
        this.updatePickupAvailability();
        this.removeErrorMessage();
        this.updateVariantStatuses();

        if (!this.currentVariant) {
            this.toggleAddButton(true, '', true);
            if (this.skipNonExistent && findAvailableVariant(this, this.options, true, true, this.skipUnavailable))
                return;
            this.setUnavailable();
        } else {
            if (this.skipUnavailable && !this.currentVariant.available) {
                if (findAvailableVariant(this, this.options, true, true, true))
                    return;
            }
            this.updateMedia();
            this.updateURL();
            this.updateVariantInput();
            this.renderProductInfo();
            this.updateShareUrl();
        }
    }

    updateOptions() {
        const optionsArr = [];
        this.querySelectorAll('.product-form__input').forEach((fieldset) => {
            let selectedValue;
            const inputType = fieldset.querySelector('.product-form__input__type').dataset.type;
            inputType == 'dropdown' || inputType == 'dropdwon'
                ? selectedValue = fieldset.querySelector('.select__select').value
                : selectedValue = fieldset.querySelector('input[type="radio"]:checked').value;
            optionsArr.push(selectedValue);
        });
        this.options = optionsArr;
    }

    updateMasterId() {
        this.currentVariant = this.getVariantData().find((variant) => {
            return !variant.options.map((option, index) => {
                return this.options[index] === option;
            }).includes(false);
        });
    }

    updateMedia() {
        if (!this.currentVariant) return;
        if (!this.currentVariant.featured_media) return;

        const mediaGalleries = document.querySelectorAll('[id^="MediaGallery-' + this.dataset.section + '"]');
        mediaGalleries.forEach((gallery) => gallery.setActiveMedia(this.dataset.section + '-' + this.currentVariant.featured_media.id, this.prependMedia, this.filtering, this.currentVariant));

        const modalContent = document.querySelector('#ProductModal-' + this.dataset.section + ' .product-media-modal__content');
        if (!modalContent) return;
        const mediaItem = modalContent.querySelector('[data-media-id="' + this.currentVariant.featured_media.id + '"]');
        modalContent.prepend(mediaItem);
    }

    updateURL() {
        if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
        window.history.replaceState({}, '', this.dataset.url + '?variant=' + this.currentVariant.id);
    }

    updateShareUrl() {
        const shareEl = document.getElementById('Share-' + this.dataset.section);
        if (!shareEl || !shareEl.updateUrl) return;
        shareEl.updateUrl('' + window.shopUrl + this.dataset.url + '?variant=' + this.currentVariant.id);
    }

    updateVariantInput() {
        const productForms = document.querySelectorAll('#product-form-' + this.dataset.section + ', #product-form-installment-' + this.dataset.section);
        productForms.forEach((form) => {
            const idInput = form.querySelector('input[name="id"]');
            idInput.value = this.currentVariant.id;
            idInput.dispatchEvent(new Event('change', { bubbles: true }));
        });
    }

    updateVariantStatuses() {
        const matchingVariants = this.variantData.filter((v) => this.querySelector(':checked').value === v.option1);
        let fieldsets;
        this.isSecondary && this.secondarySelect
            ? fieldsets = [...this.secondarySelect.querySelectorAll('.product-form__input')]
            : fieldsets = [...this.querySelectorAll('.product-form__input')];

        fieldsets.forEach((fieldset, index) => {
            if (index === 0) return;
            const inputs = [...fieldset.querySelectorAll('input[type="radio"], .select__select option')];
            const prevValue = fieldsets[index - 1].querySelector(':checked').value;
            const availableOptions = [];
            const existingOptions = [];
            const optionKey = 'option' + index;
            const nextOptionKey = 'option' + (index + 1);
            for (let i = 0; i < matchingVariants.length; i++) {
                const v = matchingVariants[i];
                if (v[optionKey] === prevValue) {
                    existingOptions.push(v[nextOptionKey]);
                    if (v.available) availableOptions.push(v[nextOptionKey]);
                }
            }
            this.setInputAvailability(inputs, availableOptions, existingOptions);
        });
    }

    setInputAvailability(inputs, availableOptions, existingOptions) {
        inputs.forEach((input) => {
            input.classList.remove('unavailable', 'non-existent', 'disabled');
            const val = input.getAttribute('value');
            let swatchEl = null;
            input.dataset.swatch === 'true' && (swatchEl = input.closest('.color-swatch'));

            if (swatchEl)
                swatchEl.classList.remove('unavailable', 'non-existent', 'disabled');

            if (existingOptions.includes(val)) {
                if (availableOptions.includes(val)) {
                    if (input.nodeName === 'OPTION')
                        input.innerText = val;
                    else {
                        input.classList.remove('disabled');
                        if (swatchEl) swatchEl.classList.remove('disabled');
                    }
                } else {
                    if (input.nodeName === 'OPTION')
                        input.innerText = window.variantStrings.unavailable_with_option.replace('[value]', val),
                        input.classList.add('unavailable');
                    else {
                        input.classList.add('disabled', 'unavailable');
                        if (swatchEl) swatchEl.classList.add('disabled', 'unavailable');
                    }
                }
            } else {
                if (input.nodeName === 'OPTION')
                    input.innerText = window.variantStrings.unavailable_with_option.replace('[value]', val),
                    input.classList.add('non-existent');
                else {
                    input.classList.add('disabled', 'non-existent');
                    if (swatchEl) swatchEl.classList.add('disabled', 'non-existent');
                }
            }
        });
    }

    updatePickupAvailability() {
        const pickupEl = document.querySelector('pickup-availability');
        if (!pickupEl) return;
        if (this.currentVariant && this.currentVariant.available) {
            if (pickupEl.fetchAvailability)
                pickupEl.fetchAvailability(this.currentVariant.id);
        } else
            pickupEl.removeAttribute('available'),
            pickupEl.innerHTML = '';
    }

    removeErrorMessage() {
        const sectionEl = this.closest('section');
        if (!sectionEl) return;
        const productFormEl = sectionEl.querySelector('product-form');
        if (productFormEl)
            productFormEl.handleErrorMessage();
    }

    renderProductInfo() {
        const variantId = this.currentVariant.id;
        const sectionId = this.dataset.originalSection || this.dataset.section;

        fetch(this.dataset.url + '?variant=' + variantId + '&section_id=' + sectionId)
            .then((res) => res.text())
            .then((html) => {
                if (this.currentVariant.id !== variantId) return;

                const parsed = new DOMParser().parseFromString(html, 'text/html');
                const sec = this.dataset.section;
                const origSec = this.dataset.originalSection || sec;

                const priceEl = document.getElementById('price-' + sec);
                const parsedPriceEl = parsed.getElementById('price-' + origSec);
                const stickyPriceSepEl = document.getElementById('sticky-atc-separate-price-' + sec);
                const parsedStickyPriceSepEl = parsed.getElementById('sticky-atc-separate-price-' + origSec);
                const stickyPriceEl = document.getElementById('sticky-atc-price-' + sec);
                const parsedStickyPriceEl = parsed.getElementById('sticky-atc-price-' + origSec);
                const stickyImageEl = document.getElementById('sticky-atc-image-' + sec);
                const parsedStickyImageEl = parsed.getElementById('sticky-atc-image-' + origSec);
                const mainAtcPriceEl = document.getElementById('main-atc-price-' + sec);
                const parsedMainAtcPriceEl = parsed.getElementById('main-atc-price-' + origSec);
                const customLabels = document.querySelectorAll('[id^="custom-label-' + sec + '"]');
                const parsedCustomLabels = parsed.querySelectorAll('[id^="custom-label-' + origSec + '"]');
                const parsedSkuEl = parsed.getElementById('Sku-' + origSec);
                const skuEl = document.getElementById('Sku-' + sec);
                const parsedInventoryEl = parsed.getElementById('Inventory-' + origSec);
                const inventoryEl = document.getElementById('Inventory-' + sec);

                if (priceEl && parsedPriceEl)
                    priceEl.innerHTML = parsedPriceEl.innerHTML;
                if (stickyPriceSepEl && parsedStickyPriceSepEl)
                    stickyPriceSepEl.innerHTML = parsedStickyPriceSepEl.innerHTML;
                if (stickyPriceEl && parsedStickyPriceEl)
                    stickyPriceEl.innerHTML = parsedStickyPriceEl.innerHTML;
                if (stickyImageEl && parsedStickyImageEl)
                    stickyImageEl.src = parsedStickyImageEl.src;
                if (parsedMainAtcPriceEl && mainAtcPriceEl)
                    mainAtcPriceEl.innerHTML = parsedMainAtcPriceEl.innerHTML;
                if (customLabels && parsedCustomLabels)
                    for (var i = 0; i < customLabels.length; i++) {
                        customLabels[i].innerHTML = parsedCustomLabels[i].innerHTML;
                    }
                if (parsedInventoryEl && inventoryEl)
                    inventoryEl.innerHTML = parsedInventoryEl.innerHTML;

                parsedSkuEl && skuEl && (
                    skuEl.innerHTML = parsedSkuEl.innerHTML,
                    skuEl.classList.toggle('visibility-hidden', parsedSkuEl.classList.contains('visibility-hidden'))
                );

                // Update QuantityBreaks
                if (this.QuantityBreaks) {
                    const parsedQB = parsed.getElementById('quantity-breaks-' + origSec);
                    if (parsedQB) {
                        const qbPrices = this.QuantityBreaks.querySelectorAll('.dynamic-price');
                        const parsedQbPrices = parsedQB.querySelectorAll('.dynamic-price');
                        for (let j = 0; j < qbPrices.length; j++) {
                            qbPrices[j].innerHTML = parsedQbPrices[j].innerHTML;
                        }
                        if (this.QuantityBreaks.hasVariants) {
                            this.QuantityBreaks.variantSelects.forEach((vs) => {
                                vs.dataset.selectedId = this.currentVariant.id;
                            });
                            const qbVariantSelects = this.QuantityBreaks.querySelectorAll('.quantity-break__variant-select');
                            const parsedQbVariantSelects = parsedQB.querySelectorAll('.quantity-break__variant-select');
                            for (let k = 0; k < qbVariantSelects.length; k++) {
                                qbVariantSelects[k].innerHTML = parsedQbVariantSelects[k].innerHTML;
                            }
                            this.QuantityBreaks.initVariants();
                        }
                    }
                }

                // Update quantity breaks picker prices
                if (this.hasQuantityBreaksPicker) {
                    const parsedVSel = parsed.getElementById('variant-selects-' + origSec);
                    if (parsedVSel) {
                        const pickerPrices = this.querySelectorAll('.dynamic-price');
                        const parsedPickerPrices = parsedVSel.querySelectorAll('.dynamic-price');
                        for (let l = 0; l < pickerPrices.length; l++) {
                            pickerPrices[l].innerHTML = parsedPickerPrices[l].innerHTML;
                        }
                        if (this.quantityBreaksPickerStyle === 'vertical' && this.quantityBreaksPickerDisplayedImages === 'variant_images') {
                            const pickerImages = this.querySelectorAll('.quantity-break__image img');
                            const parsedPickerImages = parsedVSel.querySelectorAll('.quantity-break__image img');
                            for (let m = 0; m < pickerImages.length; m++) {
                                pickerImages[m].src = parsedPickerImages[m].src;
                            }
                        }
                    }
                }

                // Update secondary select
                if (this.secondarySelect) {
                    const parsedSecondary = parsed.getElementById('' + this.secondarySelectSelector + origSec);
                    if (parsedSecondary)
                        this.secondarySelect.innerHTML = parsedSecondary.innerHTML;
                }

                const priceContainer = document.getElementById('price-' + this.dataset.section);
                if (priceContainer)
                    priceContainer.classList.remove('visibility-hidden');

                this.dataset.options = this.currentVariant.options.join(',');

                if (inventoryEl && parsedInventoryEl)
                    inventoryEl.classList.toggle('visibility-hidden', parsedInventoryEl.innerText === '');

                const submitBtn = parsed.getElementById('ProductSubmitButton-' + sectionId);
                this.toggleAddButton(submitBtn ? submitBtn.hasAttribute('disabled') : true, window.variantStrings.soldOut);

                publish(PUB_SUB_EVENTS.variantChange, {
                    data: {
                        sectionId: sectionId,
                        html: parsed,
                        variant: this.currentVariant
                    }
                });
            });
    }

    toggleAddButton(disable = true, text, updateInputs = true) {
        const productForm = document.getElementById('product-form-' + this.dataset.section);
        if (!productForm) return;

        const addButton = productForm.querySelector('[name="add"]');
        const additionalAtcBtns = document.querySelectorAll('.main-product-atc');
        var btnLabel = productForm.querySelector('.main-atc__label__text');
        if (!btnLabel) btnLabel = productForm.querySelector('.main-atc__label');
        const mainAtcPrice = productForm.querySelector('.main-atc-price');

        if (!addButton) return;

        if (disable) {
            addButton.setAttribute('disabled', 'disabled');
            addButton.setAttribute('data-unavailable', 'true');
            if (text) btnLabel.textContent = text;
            additionalAtcBtns.forEach((btn) => {
                btn.setAttribute('disabled', 'disabled');
            });
            if (mainAtcPrice)
                mainAtcPrice.classList.add('hidden');
        } else {
            addButton.setAttribute('data-unavailable', 'false');
            btnLabel.textContent = window.variantStrings.addToCart;
            if (mainAtcPrice)
                mainAtcPrice.classList.remove('hidden');
            addButton.dataset.requiredFields === addButton.dataset.validFields && (
                addButton.removeAttribute('disabled'),
                additionalAtcBtns.forEach((btn) => {
                    btn.removeAttribute('disabled');
                })
            );
        }
        if (!updateInputs) return;
    }

    setUnavailable() {
        const productForm = document.getElementById('product-form-' + this.dataset.section);
        if (!productForm) return;

        const addButton = productForm.querySelector('[name="add"]');
        var btnLabel = productForm.querySelector('.main-atc__label__text');
        if (!btnLabel) btnLabel = productForm.querySelector('.main-atc__label');
        const priceEl = document.getElementById('price-' + this.dataset.section);
        const inventoryEl = document.getElementById('Inventory-' + this.dataset.section);
        const skuEl = document.getElementById('Sku-' + this.dataset.section);

        if (!addButton) return;

        btnLabel.textContent = window.variantStrings.unavailable;
        if (priceEl) priceEl.classList.add('visibility-hidden');
        if (inventoryEl) inventoryEl.classList.add('visibility-hidden');
        if (skuEl) skuEl.classList.add('visibility-hidden');
    }

    getVariantData() {
        return this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent),
        this.variantData;
    }
}
customElements.define('variant-selects', VariantSelects);

class SecondaryVariantSelect extends VariantSelects {
    constructor() {
        super();
        this.secondarySelectSelector = 'variant-selects-';
        this.secondarySelect = document.getElementById('' + this.secondarySelectSelector + this.dataset.section);
        this.isSecondary = true;
    }
    updateOptions() {
        this.options = this.querySelector('select').value.split(',');
    }
}
customElements.define('secondary-variant-select', SecondaryVariantSelect);

class SecondaryVariantSelectSeparate extends VariantSelects {
    constructor() {
        super();
        this.secondarySelectSelector = 'variant-selects-';
        this.secondarySelect = document.getElementById('' + this.secondarySelectSelector + this.dataset.section);
        this.isSecondary = true;
    }
}
customElements.define('secondary-variant-select-separate', SecondaryVariantSelectSeparate);

class CardVariantSelects extends VariantSelects {
    constructor() {
        super();
        this.quickAddSubmit = document.getElementById(this.dataset.section + '-submit');
    }

    onVariantChange() {
        this.updateOptions();
        this.updateMasterId();
        this.toggleAddButton(true, '', false);
        this.updateVariantStatuses();
        !this.currentVariant
            ? (this.toggleAddButton(true, '', true), this.setUnavailable())
            : (this.updateMedia(), this.updateVariantInput(), this.updateQuickAddUrl(),
               this.toggleAddButton(!this.currentVariant.available, window.variantStrings.soldOut));
    }

    updateMedia() {
        if (!this.currentVariant || !this.currentVariant.featured_media) return;

        const cardImage = document.getElementById(this.dataset.section + '-image');
        if (!cardImage) return;

        const previewImage = this.currentVariant.featured_media.preview_image;
        if (!previewImage) return;
        const baseSrc = previewImage.src.split('?')[0];
        const widths = [165, 360, 533, 720, 940, 1066];
        const srcset = widths.filter((w) => previewImage.width >= w).map((w) => baseSrc + '?width=' + w + ' ' + w + 'w').join(', ');
        cardImage.srcset = srcset + ', ' + baseSrc + ' ' + previewImage.width + 'w';
        cardImage.src = baseSrc + '?width=533';
    }

    updateQuickAddUrl() {
        if (!this.currentVariant || !this.quickAddSubmit) return;
        this.quickAddSubmit.dataset.productUrl = this.dataset.url + '?variant=' + this.currentVariant.id;
    }
}
customElements.define('card-variant-selects', CardVariantSelects);

class VariantOfferStack extends HTMLElement {
    constructor() {
        super();
        // Reuses the VariantSelects sync pipeline (updateMedia / updateURL /
        // renderProductInfo / toggleAddButton) via prototype delegation — those
        // methods only rely on this.dataset.* and this.currentVariant, which this
        // element provides. Radios carry variant ids directly, so no option matching.
        this.secondarySelectSelector = 'StickyAtcVariantPicker-';
        this.secondarySelect = document.getElementById('' + this.secondarySelectSelector + this.dataset.section);
        this.prependMedia = this.dataset.disablePrepend != 'true';
        this.filtering = this.dataset.hasFiltering === 'true';
        this.radios = Array.from(this.querySelectorAll('input[type="radio"]'));

        // Cached DOM references — queried once, reused on every selection change.
        this.productForm = document.getElementById('product-form-' + this.dataset.section);
        this.idInputs = Array.from(document.querySelectorAll(
            '#product-form-' + this.dataset.section + ' input[name="id"], ' +
            '#product-form-installment-' + this.dataset.section + ' input[name="id"]'
        ));
        this.atcLabel = this.productForm
            ? (this.productForm.querySelector('.main-atc__label__text') || this.productForm.querySelector('.main-atc__label'))
            : null;
        // Snapshot the merchant's custom ATC label so enable paths can restore it
        // (VariantSelects' enable branch overwrites it with the generic string).
        if (this.atcLabel && this.atcLabel.textContent.trim() !== window.variantStrings.soldOut)
            this.defaultAtcLabel = this.atcLabel.textContent;

        this.radios.forEach((radio) => {
            radio.addEventListener('change', this.onRadioChange.bind(this));
        });

        // Initial sync: the hidden input[name="id"] is rendered with
        // selected_or_first_available_variant; if the preselected card differs,
        // align the form (and dependent UI) immediately, before any user change.
        const checkedRadio = this.querySelector('input[type="radio"]:checked');
        if (!checkedRadio) {
            // No selectable card (e.g. every card sold out or hidden): the form's
            // hidden variant is not represented by any card — block the ATC.
            this.toggleAddButton(true, window.variantStrings.soldOut);
            return;
        }
        const variant = this.getVariantData().find((v) => v.id === parseInt(checkedRadio.value));
        if (!variant) return;
        this.currentVariant = variant;
        const needsSync = this.idInputs.some((input) => parseInt(input.value) !== variant.id);
        this.updateVariantInput();
        if (!variant.available)
            this.toggleAddButton(true, window.variantStrings.soldOut);
        if (needsSync) {
            this.renderProductInfo();
            // Align the gallery with the preselected card too (onRadioChange already
            // does this for user changes). media-gallery is defined in a separate
            // deferred file, so wait for its upgrade before calling setActiveMedia.
            if (this.dataset.updateMedia === 'true')
                customElements.whenDefined('media-gallery').then(() => this.updateMedia());
        }
    }

    onRadioChange(event) {
        const variant = this.getVariantData().find((v) => v.id === parseInt(event.target.value));
        if (!variant) return;
        this.currentVariant = variant;
        this.updateVariantInput();
        this.toggleAddButton(!variant.available, window.variantStrings.soldOut);
        if (this.dataset.updateMedia === 'true') this.updateMedia();
        this.updateURL();
        this.renderProductInfo();
    }

    updateVariantInput() {
        // Cached-elements version of VariantSelects.prototype.updateVariantInput.
        this.idInputs.forEach((input) => {
            input.value = this.currentVariant.id;
            input.dispatchEvent(new Event('change', { bubbles: true }));
        });
    }

    updateMedia() {
        VariantSelects.prototype.updateMedia.call(this);
    }

    updateURL() {
        VariantSelects.prototype.updateURL.call(this);
    }

    renderProductInfo() {
        VariantSelects.prototype.renderProductInfo.call(this);
    }

    toggleAddButton(disable, text) {
        VariantSelects.prototype.toggleAddButton.call(this, disable, text);
        if (!disable && this.atcLabel && this.defaultAtcLabel !== undefined)
            this.atcLabel.textContent = this.defaultAtcLabel;
    }

    getVariantData() {
        return this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent),
        this.variantData;
    }
}
customElements.define('variant-offer-stack', VariantOfferStack);
